import React, { useEffect, useState, useRef } from 'react';
import {useHistory} from 'react-router-dom'
import { Modal } from 'react-bootstrap';
import api from '../../seller-apis/api';
import axios from 'axios';
import ConfirmationModal from './ConfirmationModal';
import servicesApi from '../../seller-apis/servicesApi';
import { Popover, OverlayTrigger, Button, Tooltip, Row } from 'react-bootstrap';
import '../order.css';
import { variables } from '../../Variables.json';
import moment from 'moment';
import PackageDetailsModal from './PackageDetailsPopup';
import HSNModal from './HSNModal';
import tpNotVerifiedIcon from '../../assets/images/ord-tp-nv.png'
import tpVerifiedIcon from '../../assets/images/ord-tp-v.png'
import pkgNotVerifiedIcon from '../../assets/images/ord-pack-nv.png'
import pkgVerifiedIcon from '../../assets/images/ord-pack-v.png'
import stockVerifiedIcon from '../../assets/images/ord-stock-v.png'
import stockNotVerifiedIcon from '../../assets/images/ord-stock-nv.png'
import OrderSelfship from './OrderSelf/OrderSelfship';
//import CheckPopup from '../OrderComponents/ProductConfirmPopup/CheckPopup';
import CheckPopup from './CheckPopup';
import { inputValidations } from '../../Validations/Inputs';
import { useAlert } from 'react-alert';
import { transformOrderDataForPackageDetails } from './orderDataTransformer';

import { pdetailData } from '../../seller-apis/apidataField';
import { useDispatch, useSelector } from 'react-redux';
import { resetPackages, setInitialPackages, setReferencePackage } from '../../Actions/PackageWeight';
import { packagesCmtoFt, packagesFttoCm } from '../../utilities/conversion';
import WeightComponent from './WeightComponent';
import { arePackagesEqual, checkIsPkgMediaNotPresent, sanitizePkgImages } from '../../utilities/packages';


let currentVendor = null
let currOrderId = null;
function OrderCardWeb(props) {
  const alert = useAlert();
  const stateData = useSelector(state => state?.ActionReducer);
  const history = useHistory()

  // Size states

  const [invoiceList, setinvoiceList] = useState([]);
  const [vendorId, setVendorId] = useState()

  // HSN Modal state
  const [showHSNModal, setShowHSNModal] = useState(false);


  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedenquiry, setselectedenquiry] = useState();
  const [confirmationresponse, setconfirmationresponse] = useState();


  // Manifest States

  const [url, seturl] = useState([]);
  const [status, setstatus] = useState();
  const [orderNo, setorderNo] = useState();
  const [index, setindex] = useState();


  // Show more tracks 

  const [showMore, setShowMore] = useState(false)


  const [notes, setNotes] = useState("")
  const [sellerManfUnderProcess, setSellerManfUnderProcess] = useState(false)
  const [generatingManifest, setGeneratingManifest] = useState(false);
  const [showPackageDetails, setShowPackageDetails] = useState(false);
  const [packageData, setPackageData] = useState(null);

  // l1-2553
  const dispatch = useDispatch();
  const { packages, initialPackages, dimensionUnit } = useSelector(state => state.packageReducer)
  const [showPackageModalForEditing, setShowPackageModalForEditing] = useState(false);
  const [viewOnlyPackageEdit, setViewOnlyPackageEdit] = useState(true);
  const [curPrdDets, setCurPrdDets] = useState()
  const [curVendSellerWeightApproved, setCurVendSellerWeightApproved] = useState()

  // Inside the component, add these new state variables after existing useState declarations:
  const [showManifestModal, setShowManifestModal] = useState(false);
  const [selectedOrderForVerification, setSelectedOrderForVerification] = useState(null);

  const [showSelfShipModal, setShowSelfShipModal] = useState(false);
  const [selectedSelfShipOrder, setSelectedSelfShipOrder] = useState(null);
 

  const [showNewManifestPopup, setShowNewManifestPopup] = useState(false);
  const [pendingManifestData, setPendingManifestData] = useState(null);
  const [popupApiData, setPopupApiData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [packageDetailsData, setPackageDetailsData] = useState(null);
  const [showPackageDetailsPopup, setShowPackageDetailsPopup] = useState(false);
  const pendingManifestDataRef = useRef(null);
  const pendingGenerateManifestRef = useRef(null);
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);

  

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData([]);
  };

async function newDownloadManifestConfirmation(url, status, orderNo, index, product, sku, order_id = null) {
  try {
    setstatus(status)
    setPendingManifestDataSync({
      url,
      status,
      orderNo,
      index,
      product,
      sku,
      order_id
    });

    // ✅ For DOWNLOAD status (Ready to Ship re-downloads),
    // skip CheckPopup entirely — go straight to Yes/No confirmation
    if (status === "DOWNLOAD" || status === "Pickup Pending") {
      handleNewManifestConfirmation(status);
      return;
    }

    // For ASSIGN status — check seller package first
    if (status === "ASSIGN") {
      const allowContinue = await checkSellerPackagePromise(props?.orderData?.product, url);
      if (!allowContinue) {
        setPendingManifestData(null);
        pendingManifestDataRef.current = null;
        return;
      }
    }

    // Order forwarded to seller — skip package-details modal; go straight to confirmation / download flow
    if (props.orderForwardedToSeller) {
      handleNewManifestConfirmation(status);
      return;
    }

    // Show CheckPopup for ASSIGN orders
    const packageData = transformOrderDataForPackageDetails(props);
    if (!packageData || !packageData.products || packageData.products.length === 0) {
      // Fallback if transformer fails
      handleNewManifestConfirmation(status);
      return;
    }

    setPackageDetailsData(packageData);
    setShowPackageDetailsPopup(true);

  } catch (error) {
    console.error('Error opening package details:', error);
    // Safe fallback — still allow download
    handleNewManifestConfirmation();
  }
}

    const handleNewManifestConfirmation = (curStatus) => {
    try {
      // If this popup was opened from the Generate Manifest flow,
      // proceed with generate manifest instead of the download flow.
      if (pendingGenerateManifestRef.current) {
        const { id, lead, btnId } = pendingGenerateManifestRef.current;
        pendingGenerateManifestRef.current = null;
        setShowPackageDetailsPopup(false);
        setPackageDetailsData(null);
        _doGenerateManifest(id, lead, btnId);
        return;
      }

      const manifestData = pendingManifestDataRef.current || pendingManifestData;

      if (!manifestData) {
        alert.info('Error: No manifest data available');
        return;
      }

      const { url, status, orderNo, index, product, sku, order_id } = manifestData;

      seturl(url);
      setstatus(status);
      setorderNo(orderNo);
      setindex(index);
      currOrderId = product + sku + '.pdf';

      if (status === "ASSIGN") {
        downloadManifest(orderNo,index,url,curStatus)
      } else if (status === "DOWNLOAD") {
        setmsgConfirmation("Do you want to download the manifest again?");
        setconfirmationState(true);
      } else {
        setmsgConfirmation("Do you want to download the manifest?");
        setconfirmationState(true);
      }


      // Clean up
      setShowPackageDetailsPopup(false);
      setPendingManifestData(null);
      pendingManifestDataRef.current = null;  // ✅ also clear the ref
      setPackageDetailsData(null);

    } catch (error) {
      console.error('Error confirming manifest:', error);
      alert.info('Error processing manifest. Please try again.');
    }
  };


  const handlePackageDetailsCancellation = () => {
    setShowPackageDetailsPopup(false);
    setPendingManifestData(null);
    setPackageDetailsData(null);
    pendingGenerateManifestRef.current = null;
  };
  
   const handleReportWrongProduct = async (payload) => {
    try {
      const response = await api.order.reportWrongProduct({
        _id: payload._id,
        orderId: payload.orderId,
        message: payload.message,
        reportType: payload.reportType,
        timestamp: payload.timestamp,
        vendorId: payload.vendorId,
        SKU: payload.SKU
      });
        
      if (response && (response.message === "Success" || response.success === true)) {
        if (props.reload) props.reload();
        return response;
      } else {
        throw new Error(response?.message || 'Failed to submit report');
      }
    } catch (error) {
      console.error('Error submitting wrong product report:', error);
      if (props.reload) props.reload();
      
      let errorMessage = 'Failed to submit report. Please try again or contact support.';
      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your connection and try again.';
      }

      alert(errorMessage);
      throw error;
    }
  };

  /**
   * Handle showing product details (placeholder for future)
   */
  const handleShowProductDetailsOld = (productUrl) => {
    try {
      if (productUrl) {
        window.open(productUrl, '_blank');
      }
    } catch (error) {
      console.error('Error showing product details:', error);
    }
  };
  function handleShowProductDetails(url) {  
  
  let data = {
    "filter": { "urlKey": url }
  };
  
  servicesApi.getProductDetail(data).then((res) => {
    // Set the data first
    props.pdetail([res.data], props.price);
    
    // Call the visibility function (this should handle the styling)
    props.popupdetailVis("2");
    
    // Wait for React to update the DOM, then find and show the element
    setTimeout(() => {
      // Target the detail popup specifically
      const detailPopup = document.querySelector('[id*="detail-popup"], [class*="detail-popup"], .detail-overlay');
      
      if (detailPopup) {
        detailPopup.style.visibility = 'visible';
        detailPopup.style.opacity = '1';
        detailPopup.style.display = 'block';
      } else {
        // Fallback: target any overlay that might be the detail popup
        const allOverlays = document.querySelectorAll('.overlay');
        
        // Show the last overlay (likely the most recent one)
        if (allOverlays.length > 0) {
          const lastOverlay = allOverlays[allOverlays.length - 1];
          lastOverlay.style.visibility = 'visible';
          lastOverlay.style.opacity = '1';
          lastOverlay.style.display = 'block';
        }
      }
    }, 100);
    
  }).catch(err => {
    console.error('API call failed:', err);
  });
}

const setPendingManifestDataSync = (data) => {
  pendingManifestDataRef.current = data;
  setPendingManifestData(data);
};

const handleNewManifestCancellation = () => {
  setShowNewManifestPopup(false);
  setPendingManifestData(null);
  setPopupApiData(null);
  setPackageDetailsData(null); // Clear package details data
};

 const handleOpenSelfShipModal = (orderProps) => {
  
    const orderData = {
      _id: orderProps.orderMainId || orderProps._id || orderProps.id,
      orderId: orderProps.orderId,
      productName: orderProps.productName,
      sku: orderProps.sku,
      quantity: orderProps.quantity || 1,
      productIndex: orderProps.productIndex || 0,
      tracks: orderProps?.invoices || orderProps.tracks || [],
      vendorDetails: orderProps.vendorDetails,
      order: orderProps.order,
      product: orderProps.product
    };

    setSelectedSelfShipOrder(orderData);
    setShowSelfShipModal(true);

  };


  const handleCloseSelfShipModal = () => {
    console.log('❌ Closing Self-Ship Modal');
    setShowSelfShipModal(false);
    setSelectedSelfShipOrder(null);
  };
  // Pricing Details Modal states (SL-1014)
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [hsnCode, setHsnCode] = useState('');
  const [gstRate, setGstRate] = useState('');
  const [currentTransferPrice, setCurrentTransferPrice] = useState(0);

  useEffect(() => {
    currentVendor = localStorage.getItem('vendorId')
    setinvoiceList(props?.invoices)
    setSellerManfUnderProcess(props.sellerManfUnderProcess)
    setVendorId(localStorage.getItem("userId"))
  }, [])

  useEffect(() => {
    setShowMore(false)
  }, [props.orderId])

  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }


  // Add this handler function:
  const handleManifestVerification = (orderId) => {
    setSelectedOrderForVerification(orderId);
    setShowManifestModal(true);
  };

  const handleManifestModalClose = () => {
    setShowManifestModal(false);
    setSelectedOrderForVerification(null);
  };

  const handleManifestSubmit = (data) => {
    console.log('Verification data:', data);
    // Add your API call here to submit verification
    // api.order.verifyManifestDetails(data).then(...)
    setShowManifestModal(false);
    // Optionally refresh the order list
    props.isManifestDownloadedFun("yes");
  };


  function responseConfirmationOrderHist(status, id, from) {

     setTimeout(() => {
    downloadManifest();
  }, 100);
    setconfirmationState(false);
  }

  // l1-2553

  const fetchPendingWeightPackages = async (product, url = null) => {
    try {
      let res = await api.product.getSellerWeightChangePendingReq({ "product": product, "pkg.url": url });
      dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
    }
    catch (error) {
      console.error("Error fetching pending weight packages:", error);
    }
  }


  async function downloadManifestConfirmation(url, status, orderNo, index, product, sku, order_id = null) {
    try {
      console.log(props?.selSubPrdVal)
      seturl(url);
      setstatus(status);
      setorderNo(orderNo);
      setindex(index);
      if (status === "ASSIGN") {
        const allowContinue = await checkSellerPackagePromise(props?.orderData?.product, url);
        if (!allowContinue) {
          console.log("User cancelled, stopping parent function.");
          return;
        }
      }

      currOrderId = product + sku + '.pdf';

      if (status === "ASSIGN") {
        setmsgConfirmation("Is the product packed?");
        setconfirmationState(true)
      }
      else if (status === "DOWNLOAD") {

        setmsgConfirmation("Do you want to download the manifest again?");
        setconfirmationState(true)
      }
      else {
        setmsgConfirmation("Do you want to download the manifest again?");
        setconfirmationState(true)
      }
    }
    catch (error) {
      console.error("Error in downloadManifestConfirmation:", error);
    }

    setconfirmationState(true);
  }

  const checkSellerPackagePromise = (product, url) => {
    return new Promise(async (resolve, reject) => {
      try {
        let curComUrl = props?.orderData?.order?.products[0]?.selSubPrd?.url;
        let data = {
          pId: product,
          selectFields: {
            "images": -1,
            "description": -1,
            "descriptionNew": -1,
            "videos": -1,
            "shortDescription": -1,
            "specificationNew": -1,
            "sellerRatings": -1,
            "reviews": -1,
          }
        };
        let res = await api.product.productsRetrieveall(pdetailData(data));
        setCurPrdDets(res?.products[0]);
  
        const vendor = res?.products?.[0]?.vendors?.[0];
        let curPackage;
  
        if (vendor?.combination?.length > 0) {
          let comb = vendor.combination.filter(item => item?.url === curComUrl);
  
          res.products[0].pkgs.forEach(item1 => {
            if (item1?.url === comb[0]?.url) {
              setCurVendSellerWeightApproved(comb[0]?.sellerWeightApproved);
  
              if (comb[0]?.sellerWeightChangeSts === "T_PENDING") {
                fetchPendingWeightPackages(product, comb[0].url);
              } else {
                curPackage = item1?.pkgs
                dispatch(setInitialPackages(packagesCmtoFt(item1.pkgs)));
              }
            }
          });
  
          res.products[0].combination.forEach(lItem => {
            if (lItem?.url === comb[0]?.url) {
              
              dispatch(setReferencePackage(packagesCmtoFt(lItem?.lowestPkgs)));
            }
          });
  
        } else {
          setCurVendSellerWeightApproved(vendor?.sellerWeightApproved);
  
          if (vendor?.sellerWeightChangeSts === "T_PENDING") {
            fetchPendingWeightPackages(product);
          } else {
            curPackage = res?.products?.[0]?.pkgs;
            dispatch(setInitialPackages(packagesCmtoFt(res?.products[0].pkgs)));
          }
          dispatch(setReferencePackage(packagesCmtoFt(res.products[0].lowestPkgs)));
        }
  
  
        if (vendor?.sellerWeightApproved || !checkIsPkgMediaNotPresent(curPackage)) {
          resolve(true); 
          return;
        }
  
        setShowPackageModalForEditing(true);
        window.__resolvePackagePromise = resolve;
  
      } catch (err) {
        reject(err);
      }
    });
  };
  
  const handleVerPackageSubmission = async () => {
    if (arePackagesEqual(packages, initialPackages)) {
      alert.info("No updates made to package.")
      handleProceedManifestCancel();
      return;
    }
    let curOrder = props?.orderData
    if(props?.sellerWeightChangeSts && checkIsPkgMediaNotPresent(packages)){
      alert.info("Please add at least one image to update package details.")
      return;
    }
    let pkgData;
    pkgData = {
      orderId: curOrder?.order?.orderId,
      product: curOrder?.product,
      status: "T_PENDING",
      pkg: curOrder?.order?.products[0]?.selSubPrd?.url ? { url: curOrder?.order?.products[0]?.selSubPrd?.url, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages } :
        { productName: curOrder?.order?.products[0]?.productId?.productName, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages },
      categories: curOrder?.order?.products[0]?.productId?.categories,
      requestType: "EXISTING_PRODUCT"
    };
    const sanitizedPkgData = sanitizePkgImages(pkgData);
    await api.product.saveSellerWeightChangeReq(sanitizedPkgData)
    props?.reload()
    handleProceedManifestCancel()
  }


  const handleProceedManifestDwnld =  () => {
    if (window.__resolvePackagePromise) {
      if (!curVendSellerWeightApproved) {
        let curOrder = props?.orderData
        let pkgData;
        pkgData = {
          product: curOrder?.product,
          status: "V_ACTIVE",
          pkg: curOrder?.order?.products[0]?.selSubPrd?.url ? { url: curOrder?.order?.products[0]?.selSubPrd?.url, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages } :
            { productName: curOrder?.order?.products[0]?.productId?.productName, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages },
          categories: curOrder?.order?.products[0]?.productId?.categories,
          requestType: "EXISTING_PRODUCT",
          sellerWeightApproved:true
        };
        const sanitizedPkgData = sanitizePkgImages(pkgData); 
        try{
          api.product.saveSellerWeightChangeReq(sanitizedPkgData)
        }
        catch(err){
          console.log(err)
        }
      }
      window.__resolvePackagePromise(true);
      window.__resolvePackagePromise = null;
      setShowPackageModalForEditing(false);
      setViewOnlyPackageEdit(true)
    }
  }

  const handleProceedManifestCancel = () => {
    if (window.__resolvePackagePromise) {
      window.__resolvePackagePromise(false); // popup cancel
      window.__resolvePackagePromise = null;
    }
    dispatch(resetPackages())
    setShowPackageModalForEditing(false);
    setViewOnlyPackageEdit(true)
  };


  const openPackage = (data) => {
    console.log(data)
    if (data.length > 0) {
      // setShowPackageDetails(true)
      // setPackageData(data);
    }
  }


  const handleSelfShipSubmit = async (payload) => {
    try {
      console.log('📤 Submitting Self-Ship Tracking:', payload);

      const apiPayload = {
        orderId: payload.orderId,
        productIndex: payload.productIndex || 0,
        packages: payload.packages,
        isUpdate: payload.isUpdate || false
      };

      const result = await api.order.submitSelfShipTracking(apiPayload);

      console.log('✅ Response:', result);

      if (result.success) {
        // Close the modal first
        handleCloseSelfShipModal();

        // Option 1: Full page reload to reset all tabs and counts
        window.location.reload();

        // Option 2: If you have a filter/refresh function passed as prop, use this instead:
        if (props.refreshOrders) {
          props.refreshOrders();
        }
        if (props.resetTabCounts) {
          props.resetTabCounts();
        }

        // Option 3: Call the parent's filter function if available
        // if (props.filterOrders) {
        //   props.filterOrders(props.currentFilter || {});
        // }

        return result;
      } else {
        throw new Error(result.message || 'Failed to submit tracking');
      }

    } catch (error) {
      console.error('❌ Error:', error);
      handleCloseSelfShipModal();
      throw error;
    }
  };

  const downloadSelfShipManifest = async (orderId) => {
    try {
      const response = await fetch(`/api/orders/self-ship-manifest/${orderId}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `manifest_${orderId}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading manifest:', error);
    }
  };
  // HSN Modal handlers
  // const handleHSNEdit = () => {
  //   props?.handleHSNModal({
  //     id: props?.orderData?.order?.products?.[0]?.productId?._id,
  //     taxClass: props?.orderData?.order?.products?.[0]?.productId?.taxClass,
  //     sku: props?.orderData?.order?.products?.[0]?.productId?.SKU,
  //     productName: props?.orderData?.order?.products?.[0]?.productId?.productName
  //   });
  //   return;
  // };
  const checkIsGstPresent = (check) => {
    if (!props?.taxClass) {
      handleOpenPricingModal(props?.price);
    }
    else {
      if (check === "starting") {
        props.manifestDetailsVerify(props.id)
      }
      else {
        props?.downloadManifestToast()
      }
    }
  }

  const renderGstLabel = (check) => {
      if (!props?.taxClass || props?.taxClass === undefined || props?.taxClass === null || props?.taxClass === "") {
        return <>Update GST</>;
      } else
        if (check === "starting") {
          if (props?.sellerWeightChangeSts === "V_PENDING") {
            if(props?.orderForwardedToSeller ||  props?.invoices?.length < 1){
              return (<>
              Generate Manifest
              </>)
            }
            return (
              <>Download Manifest<i className='fa fa-arrow-down'></i></>
            )
          }
          else {
            return (
              <>Verify Details to generate manifest</>
            )
          }
        }
        else {
          return (
            <>
              Manifest Under Process <img src="/gear-icon.webp" />
            </>
          );
        }
  };


  const renderGstPresentStyle = () => {
    if (!props?.taxClass) {
      return { backgroundColor: '#165b5b', color: 'white', cursor: 'pointer' };
    }
    return {};
  }


  // Pricing Modal handlers
  const handleOpenPricingModal = (price) => {
    setCurrentTransferPrice(price);
    setShowPricingModal(true);
    setHsnCode(props?.HSN || '');
    setGstRate(props?.taxClass || '');
  }


  const handleClosePricingModal = () => {
    setShowPricingModal(false);
    setHsnCode('');
    setGstRate('');
  };

  const handlePricingSubmit = async () => {
    const validation = inputValidations.hsn(hsnCode);
    if (!validation.status) {
      alert.info(validation.msg);
      return;
    }
    if (!gstRate && gstRate !== 0) {
      alert.info('Please select a GST rate');
      return;
    }

    const data = {
      _id: props?.orderData?.product,
      taxClass: gstRate
    };
    if (props?.HSN !== hsnCode) data.HSN = hsnCode;

    try {
      const res = await api.product.addToExProduct(data);
      setShowPricingModal(false);
      alert.success('success');
      props?.reload();
    } catch (err) {
      console.error(err);
      alert.info("Failed to save pricing — try again.");
    }
  };


  // SL-997
  const extractOrderPath = (url) => {
    if (url.startsWith("https://")) {
      const index = url.indexOf("orders");
      if (index !== -1) {
        return url.substring(index);
      }
    }
    return null;
  }

  const downloadManifestPdf = (order,ind,urlVal) => {
    let ele;
    let urlToUse;
    if(order){
      ele = document.getElementById(order + ind);
      urlToUse = urlVal?.[0]?.invoice;
    }else{
      ele = document.getElementById(orderNo + index);
      urlToUse = url?.[0]?.invoice;
    }

    const urlKey = extractOrderPath(urlToUse);
    if (!urlKey) throw new Error("Invoice not present");

    const payload = {
      bucket: "seller_doc",
      key: urlKey
    };

    api.docs.getImage(payload)
      .then(async (response) => {
        const fileUrl = response?.data;
        if (!fileUrl) throw new Error("No PDF URL returned");

        const fileResponse = await fetch(fileUrl);
        const blob = await fileResponse.blob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${currOrderId}`;
        document.body.appendChild(link);
        link.click();
        window.open(link, "_blank")
        URL.revokeObjectURL(link.href);
        link.remove();
        ele.innerHTML = "Download Manifest";
      })
      .catch((err) => {
        console.log(err);
        if (ele) ele.innerHTML = "<p>Not found</p>";
      });
  };

  async function downloadManifest(order, ind, url, curStatus) {
    let orderStatus = curStatus || status;
    let downloadName;
    let ele;
    if (order) {
      ele = document.getElementById(order + ind);
    }
    else {
      ele = document.getElementById(orderNo + index);
    }
    if (orderStatus === "ASSIGN" || orderStatus === "DOWNLOAD" || orderStatus === "Pickup Pending" || order) {
      ele.innerHTML = "Loading...";
      if (status === "ASSIGN" || order) {
        downloadManifestPdf(order, ind, url);
      }
      else {
        downloadManifestPdf();
      }

      ele.innerHTML = "Loading...";
      // for (let i = 0; i < url.length; i++) {

      if (props?.invoices?.[0]?.shippingBy === "ROCKET BOX" || props?.invoices?.[0]?.shippingBy === "ROCKETBOX-MANUAL") {
        api.order.rocketBoxManifest({ _id: props.orderMainId }).then((res) => {
          console.log(res)

          const link = document.createElement('a');
          link.href = res.data.label_url;
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();
        }).catch((error) => {
          console.error('Error downloading manifest:', error);
        });
      }
      else if (props?.invoices?.[0]?.shippingBy === "SHIPROCKET") {
        const link = document.createElement('a');
        link.href = props?.invoices?.[0]?.label_url;
        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();
      }
      else if (props?.invoices?.[0]?.shippingBy === "SHIPYAARI" || props?.invoices?.[0]?.shippingBy === "SHIPYAARI MANUAL") {
        const res = await api.order.downloadShipyaari({ awb: props?.invoices?.[0]?.docketNo });
        const resUrl = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = resUrl;
        link.setAttribute('download', "Shipyaari-" + currOrderId);
        document.body.appendChild(link);
        link.click();
      }
      else if (props?.invoices?.[0]?.shippingBy === "NIMBUSPOST") {
        const link = document.createElement('a');
        link.href = props?.invoices[0]?.label_url;
        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();
      }
      else if (props?.invoices?.[0]?.shippingBy === "DELHIVERYB2B") {
          const lrnum = props?.invoices?.[0]?.lrnum;
          if (lrnum) {
              await downloadDelhiveryB2BLabel(lrnum, props.orderId);
          } else {
              console.error('No lrnum found for DELHIVERYB2B shipment');
          }
      }


      // }
    }
    else {
      ele.removeAttribute("class");
      ele.innerHTML = "Loading...";
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (response.status === 200) {
          const newurl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = newurl;
          // downloadName = url.slice(77);
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();
          ele.innerHTML = "";
          ele.setAttribute("class", "bi bi-arrow-down-circle-fill download-Manifest-btn");
          window.open(response.config.url, '_blank');
        }
      }).catch((err) => {
        console.log(err)
        ele.innerHTML = "<p>Not found</p>"
      })
    }


    if (orderStatus === "ASSIGN") {
      let ordNo = orderNo ? orderNo : order;
      let data = {
        "_id": ordNo,
        "status": props?.orderForwardedToSeller === true ? "Pickup Pending":"DOWNLOAD",
        "platform": 'WEB'
      }
      api.order.updateOrder(data).then((res) => {
        props.isManifestDownloadedFun("yes");
        if(props?.orderForwardedToSeller){
          history.push("/my-order/pickup-request")
        }
      }).catch(err => console.log(err))
    }

    // l1-1735
    if (props.status === "dispatch") {
      let data = props.fullObj;
      if (data?.redispatchData?.redispatch?.pkgs && data?.redispatchData?.redispatch?.pkgs.length > 0) {
        data.redispatchData.redispatch.pkgs[0].downloadStatus = true;
      }
      else {
        if (data?.redispatchData?.redispatch) {
          data.redispatchData.redispatch.downloadStatus = true;
        }
        else {
          data.downloadStatus = true;
        }
      }
      api.supportTicket.updateReadMessage(data).then((res) => {
      }).catch(err => console.log(err))
    }

  }

  function productPickedfun(id, status, pname) {
    props.isProductPickedFun(id, status, pname)
  }
  //<Start-Here> Track issue | Ticket : SL-950
  function sendData(propNo, docketNo) {
    // get track data
    if ((props.status === 'reverse' || props.status === 'dispatch') && props?.pkgs) {
      // For reverse orders, use pkgs instead of invoices
      api.clickpost.track(props?.pkgs?.[propNo].docketNo, props?.pkgs?.[propNo]?.cId).then((res => {
        let transitDetail = props?.pkgs[propNo].transitDetail;
        let docket = props?.pkgs[propNo].docketNo;
        if (res?.data && res?.data?.length > 0) {
          transitDetail = res.data || [];
        }
        props.onTransitFetched(props.lead, transitDetail, props.id, propNo);
        /*props?.pkgs[propNo].transitDetail = transitDetail;
        props.fun(props.id, propNo, docket)
        props.popupVisibility("2")*/
      })).catch(err => {
        console.log(err)
        /*let docket = props?.pkgs[propNo].docketNo;
        props?.pkgs[propNo].transitDetail = [];
        props.fun(props.id, propNo, docket)
        props.popupVisibility("2")*/
      })
    } else {
      api.clickpost.track(props?.invoices?.[propNo].docketNo, props?.invoices?.[propNo]?.cId).then((res => {
        let transitDetail = props?.invoices[propNo].transitDetail;
        //let docket = props?.invoices[propNo].docketNo;
        if (res?.data && res?.data?.length > 0) {
          transitDetail = res.data || [];
        }
        props.onTransitFetched(props.lead, transitDetail, props.id, propNo);
        /*props?.invoices[propNo].transitDetail = transitDetail;
        props.fun(props.id, propNo, docketNo)
        props.popupVisibility("2")*/
      })).catch(err => {
        console.log(err)
        /*props?.invoices[propNo].transitDetail = [];
        props.fun(props.id, propNo, docketNo)
        props.popupVisibility("2")*/
      })
    }
  }
  //</End-Here> Track issue | Ticket : SL-950

  // For detail of product

  function detailnew(url) {
    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      props.pdetail([res.data], props.price)

      props.popupdetailVis("2");
    }).catch(err => console.log(err))

  }



  // Revoke check

  function revokeUpdt(id) {
    console.log(id)
    let data = {
      "_id": id,
      "status": "REVOKED",
      "rClk": true
    }
    api.order.updateOrder(data).then((res) => {
      console.log(res)
      if (res.message === "record updated") {
        props.revokeCheck("success");
      }
      else {
        props.revokeCheck("failed");
      }
    }).catch(err => console.log(err))
  }


  function addNote(e, id) {
    props.addNotes(document.getElementById(e).value, id, e);
  }

  // generate manifest - public entry point from buttons.
  // For non pickup-pending flow, show the same CheckPopup used in the
  // download manifest flow; only proceed to generate when user confirms.
  async function generateManifest(id, lead, btnId) {
    if (props?.from !== "pickup-pending") {
      try {
        const packageData = transformOrderDataForPackageDetails(props);
        if (!packageData || !packageData.products || packageData.products.length === 0) {
          return _doGenerateManifest(id, lead, btnId);
        }
        pendingGenerateManifestRef.current = { id, lead, btnId };
        setPackageDetailsData(packageData);
        setShowPackageDetailsPopup(true);
        return;
      } catch (error) {
        console.error('Error opening package details for generate manifest:', error);
        return _doGenerateManifest(id, lead, btnId);
      }
    }
    return _doGenerateManifest(id, lead, btnId);
  }

  async function _doGenerateManifest(id, lead, btnId) {
  setGeneratingManifest(true);
  const data = { id };
    const fromDateValue = moment().subtract(30, 'days').format('YYYY-MM-DD');
    const toDateValue = moment().format('YYYY-MM-DD'); 

  try {
    if (props?.from === "pickup-pending") {
      const res = await api.order.generateManifestStepSecond(data);

      if (res.message === "Success docket saved") {
        const data2 = {
          "_id": lead,
          "status": "DOWNLOAD",
          "platform": 'WEB'
        };

        try {
          await api.order.updateOrder(data2);
          props?.pickupReqGeneratedFun("yes");
        } catch (err) {
          console.error(err);
          alert.error(err?.message || "Failed to update order status. Please try again.");
        }
      } else {
        alert.info(res?.message || "Failed to generate request. Please try again.");
      }
    } else {
      const logisticErrorCheckRes = await api.order.logisticErrorLogsRetrieveAll(
        {
          "pageNo": 1,
          "size": 1,
          "filter": {
            "to-createdAt": toDateValue,
            "from-createdAt": fromDateValue,
            "orderId": props.orderId
          },
          "sortFilter": {
            "_id": -1
          }
        });
      if(logisticErrorCheckRes?.totalRecords > 0) {
        alert.info("The manifest will be generated by the Toolsvilla team and will be available shortly.");
        return;
      }
      const isDelhiveryB2B = props?.invoices?.[0]?.shippingBy === "DELHIVERYB2B";

      const res = await api.order.generateManifestStepFirst(data);

      // Only for DELHIVERYB2B: wait a few seconds for the docket to be
      // generated on the backend, then fetch it by job id and persist
      // lrnum/docketNo on the order before notifying the parent.
      if (isDelhiveryB2B && props?.orderMainId) {
        try {
          const waitMs = 6000;
          const extractLrnumDocket = (r) => ({
            lrnum: r?.data?.lrnum ?? r?.data?.data?.lrnum,
            docketNo: r?.data?.docketNo ?? r?.data?.data?.docketNo,
          });
          const isProcessing = (r) => r?.data?.data?.status === "Processing";

          await new Promise((resolve) => setTimeout(resolve, waitMs));

          let docketRes = await api.order.getDocketByJobId({ _id: props.orderMainId });

          // If backend is still processing, retry once immediately.
          if (isProcessing(docketRes)) {
            docketRes = await api.order.getDocketByJobId({ _id: props.orderMainId });
          }

          const { lrnum: lrnumFromDocket, docketNo: docketNoFromDocket } = extractLrnumDocket(docketRes);

          if (lrnumFromDocket && docketNoFromDocket) {
            const updateOrderKeyRes = await api.order.updateOrderKeys({
              _id: props.orderMainId,
              lrnum: lrnumFromDocket,
              docketNo: docketNoFromDocket,
            });
            if (updateOrderKeyRes?.message === "Success") {
                props.isManifestDownloadedFun("yes");
            }
          } else {
            console.error('getDocketByJobId did not return lrnum/docketNo:', docketRes);
          }
        } catch (docketErr) {
          console.error('Error updating order keys for DELHIVERYB2B:', docketErr);
        }
      }

      if (res.message === "Success docket saved") {
        props.isManifestDownloadedFun("yes");
      } else {
        alert.info(res?.message || "Failed to generate manifest. Please try again.");
      }
    }
  } catch (err) {
    console.error(err);
    alert.error(err?.message || "An unexpected error occurred. Please try again.");
  } finally {
    setGeneratingManifest(false);
    setSellerManfUnderProcess(false);
  }
}

  //download seller generated invoice
  function getSellerInvoice(_id, orderId, status, orderVendNo) {
    api.vendorledger.orderInvoice(_id).then((res) => {
      let blob = new Blob([res.data], { type: 'application/pdf' });
      var downloadURL = window.URL.createObjectURL(blob);
      var newWindow = window.open(downloadURL);
      newWindow.document.title = orderId;
    }).catch(err => console.log(err))
    // if (status === "ASSIGN") {
    //   console.log("make DOWNLOAD");
    //   let data = {
    //     "_id": orderVendNo,
    //     "status": "DOWNLOAD",
    //     "platform": 'WEB'
    //   }
    //   api.order.updateOrder(data).then((res) => {

    //     props.isManifestDownloadedFun("yes");
    //   }).catch(err => console.log(err))
    // }
  }

  // SL-967(17-10-25)
  const renderReasonOverlay = (reason) => {
    if (reason === "Seller Issue" || reason === "Courier Issue") {
      return (
        <OverlayTrigger
          key="tds"
          placement="bottom"
          overlay={
            <Tooltip id={`tooltip-tds`} className="fs-16 order_page_tooltip">
              <p className='fs-10 f-500 payment_page_tooltip_1'> {reason === "Seller Issue" ? "The order will be reassigned to a new seller." : "A new manifest will be shared.Please remove the old manifest if already printed."}
              </p>
            </Tooltip>
          }
        >
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </OverlayTrigger>
      )
    }
  }


  const downloadDelhiveryB2BLabel = async (lrnum, orderId) => {
    try {
        const parsedData = await api.order.delhiveryB2BLabel(lrnum);

        // Label still being generated
        const presignedUrl = parsedData?.labels?.presigned_url;

        if (!presignedUrl) {
            console.error('❌ No presigned_url found:', parsedData);
            alert.info("Could not get download link. Please try again.");
            return;
        }

        // Direct link download — same as SHIPROCKET/NIMBUSPOST pattern
        const link = document.createElement('a');
        link.href = presignedUrl;
        link.setAttribute('target', '_blank');
        link.setAttribute('download', `DelhiveryB2B-${orderId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        // 400 = label being generated
        if (error?.response?.status === 400) {
            const message = error?.response?.data?.message;
            alert.info(message || "Label is being generated. Please wait and try again.");
            return;
        }
        console.error('❌ Top level error:', error.message);
    }
};

  // sl - 712
  // sachin

  const styles = {
    iconsContain: {
      container: {
        width: "94%",
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "5px"
      },
      iconParent: {
        width: "35px",
        height: "35px"
      },
      icon: {
        width: "100%",
        height: "100%"
      }
    }
  }

  // SL-1014
  const renderGstConfirmModal = () => {
    return (
      <Modal
        show={showPricingModal}
        onHide={handleClosePricingModal}
        centered
        className="pricing-modal"
      >
        <Modal.Header style={{ backgroundColor: 'teal', color: 'white', border: 'none' }}>
          <Modal.Title style={{ fontWeight: '600', fontSize: '20px' }}>Confirm Pricing details</Modal.Title>
          <button
            type="button"
            className="btn-close btn-close-white"
            aria-label="Close"
            onClick={handleClosePricingModal}
          ></button>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <p style={{ color: '#999', fontSize: '16px', marginBottom: '5px' }}>Current Transfer Price : <span style={{ color: '#333', fontWeight: '600', fontSize: '16px' }}>₹ {currentTransferPrice}</span></p>
          </div>

          <div className="form-group" style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', textAlign: 'center', color: 'black', marginBottom: '10px', fontSize: '14px', fontWeight: '600' }}>
              HSN Code <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="number"
              className="form-control"
              value={hsnCode}
              onChange={(e) => setHsnCode(e.target.value)}
              onWheel={(e) => e.target.blur()}
              style={{
                textAlign: 'center',
                padding: '8px',
                fontSize: '14px',
                border: '1px solid #ddd',
                borderRadius: '8px'
              }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', textAlign: 'center', color: 'black', marginBottom: '10px', fontSize: '14px', fontWeight: '600' }}>
              GST Rate <span style={{ color: 'red' }}>*</span>
            </label>
            <select
              className="form-control"
              value={gstRate || ''}
              onChange={(e) => setGstRate(e.target.value)}
              style={{
                textAlign: 'center',
                padding: '8px',
                fontSize: '14px',
                border: '1px solid #ddd',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              <option value="">N/A</option>
              <option value="0">0%</option>
              <option value="5">5%</option>
              <option value="18">18%</option>
            </select>
          </div>

          <div style={{ textAlign: 'center' }}>
            <button
              onClick={handlePricingSubmit}
              style={{
                backgroundColor: 'teal',
                color: 'white',
                border: 'none',
                padding: '5px 50px',
                fontSize: '17px',
                fontWeight: '600',
                borderRadius: '8px',
                cursor: 'pointer',
                textTransform: 'uppercase'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#3a7566'}
              onMouseOut={(e) => e.target.style.backgroundColor = 'teal'}
            >
              SUBMIT
            </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

const handleCloseOrderDetailsModal = () => {
  setShowOrderDetailsModal(false);
};
const [copied, setCopied] = useState(false);
const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  setCopied(true);

  setTimeout(() => {
    setCopied(false);
  }, 2000);
};
const renderCustomerContactModal = (phoneNumber, paymentMethod) => {
  // check partial payment
  let collectAmt = props.order?.actualPrice;
  if (paymentMethod == "online") {
    collectAmt = 0;
  } else {
    if (props.order?.partialPayments) {
      props.order.partialPayments.forEach((pt) => {
        if (pt.status == "paid") {
          collectAmt = collectAmt - pt.amount;
        }
      });
    }
  }
  const paymentMode = paymentMethod === "online" ? "Online" : "COD";
  return (
    <Modal
      show={showOrderDetailsModal}
      onHide={handleCloseOrderDetailsModal}
      centered
      className="orderDetails"
    >
      <Modal.Header className="orderDetails-header">
        <Modal.Title className="orderDetails-title">
          Order Details
        </Modal.Title>

        <button
          type="button"
          className="btn-close orderDetails-close"
          aria-label="Close"
          onClick={handleCloseOrderDetailsModal}
        ></button>
      </Modal.Header>

      <Modal.Body className="orderDetails-body">

        {/* Customer Contact */}
        <div className="orderDetails-info">
          <span>Customer Contact: </span>

          <span className="orderDetails-value">
            {phoneNumber}
            <i 
              className="fa fa-copy"
              onClick={() => copyToClipboard(phoneNumber)}
              title="Copy phone number">
            </i>
            {copied && <span className="copied-text">Copied!</span>}
          </span>
        </div>

        {/* Payment Mode */}
        <div className="orderDetails-info orderDetails-payment">
          <span className="orderDetails-payment-label">
            Payment Mode:
          </span>

          <span className="orderDetails-payment-badge">
            {paymentMode}
          </span>
        </div>

        {/* Collectible Amount Details */}
        <div className="orderDetails-section-title">
          Collectible Amount Details
        </div>

        {/* Total Collectible Amount */}
        <div className="orderDetails-total">
          <span>Total Collectible Amount: </span>

          <span className="orderDetails-amount">
            ₹{collectAmt}
          </span>
        </div>

        {/* Close Button */}
        <div className="orderDetails-close-container">
          <button
            type="button"
            className="orderDetails-close-button"
            onClick={handleCloseOrderDetailsModal}
          >
            Close
          </button>
        </div>

      </Modal.Body>
    </Modal>
  )
}

// SL-1159
const renderManifestActionButon = () => {
  if (props.product?.selfShip === true ||
    props.order?.products?.[0]?.productId?.selfShip === true) {
    const showDownloadBtn = props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0]?.docketNo;
    return (
      <button
        className="download_manifest_btn_orders"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleOpenSelfShipModal(props);
        }}
        type="button"
      >
        {showDownloadBtn ? <>Download Manifest <img src="/note.webp" /></> : <>Generate Manifest</>}
      </button>
    )
  }
  else if(props.type === "New-Orders" && props.showVerifyToGenManifest){
    return(
       <button 
        className="download_manifest_btn_orders icon-but mb-1" 
        id={props.lead + index} 
        onClick={() => checkIsGstPresent("starting")}
      >
        {renderGstLabel("starting")}
      </button>
    )
  }
  else if(props.wrongProReportStatus === 'PENDING'){
    return(
      <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-wrong-product-${props.id}`}>
                <strong>Issue reported:</strong><br />
                {props.wrongProductReportMessage}
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <button
                className="download_manifest_btn_orders icon-but"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  backgroundColor: '#6c757d',
                  cursor: 'not-allowed',
                  opacity: 0.6,
                  whiteSpace: 'nowrap',
                }}
                disabled
              >
                Manifest Rejected
                <img src="/gear-icon.webp" alt="Note icon" style={{ height: '1em' }} />
              </button>
            </span>
          </OverlayTrigger>
    )
  }
  else if (props.wrongProReportStatus === 'REJECTED') {
    if (props.orderForwardedToSeller && props.docketNotGenerated) {
      return(
      <button
        className="download_manifest_btn_orders"
        id={"genmanifest" + props.lead + index}
        disabled={generatingManifest}
        onClick={() => generateManifest(props.orderMainId, props.lead, "genmanifest" + props.lead + index)}
      >
        {generatingManifest ? "Generating Manifest..." : "Generate Manifest"}
      </button>
      )
    }
    else {
      return(
      <button
        className="download_manifest_btn_orders icon-but"
        id={props.lead + index}
        onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
      >
        Download Manifest <img src="/note.webp" />
      </button>
      )
    }
  }
  else if(!props.showVerifyToGenManifest){

    if(!props.orderForwardedToSeller && props?.invoices && props?.invoices?.length > 0 ){
      return(
          <>
            <button 
              className="download_manifest_btn_orders icon-but" 
              id={props.lead + index} 
              onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
            >
              Download Manifest <img src="/note.webp" />
            </button>
          </>
      )
    }
    else if(!props.orderForwardedToSeller && (!props?.invoices || props?.invoices?.length === 0)){
      return(
         <button 
        style={renderGstPresentStyle()} 
        className="download_manifest_btn_orders mni-under-process icon-but" 
        id={props.lead + index} 
        onClick={() => checkIsGstPresent()}
      >
        {renderGstLabel()}
      </button>
      )
    }
    else if(props.orderForwardedToSeller){
      if((generatingManifest || !sellerManfUnderProcess) && props.docketNotGenerated){
        return(
           <button 
            className="download_manifest_btn_orders" 
            id={"genmanifest" + props.lead + index} 
            disabled={generatingManifest}
            onClick={() => generateManifest(props.orderMainId, props.lead, "genmanifest" + props.lead + index)}
          >
            {generatingManifest ? (props?.from === "pickup-pending" ? "Generating Pickup Request..." : "Generating Manifest...") : "Generate Manifest"}
          </button>
        )
      }
      else if(sellerManfUnderProcess && props.docketNotGenerated){
        return(
          <button 
            style={renderGstPresentStyle()} 
            className={"download_manifest_btn_orders mni-under-process icon-but"} 
            id={props.lead + index} 
            onClick={() => checkIsGstPresent()}
          >
            {renderGstLabel()}
          </button>
        )
      }
      else if(!sellerManfUnderProcess && !props.docketNotGenerated){
        return(
           <button 
              className="download_manifest_btn_orders icon-but" 
              id={props.lead + index} 
              onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
            >
              Download Manifest <img src="/note.webp" />
            </button>
        )
      }
    }
  }
}

  if (props.status === "noprodetail") {
    // return (
    //   <>
    //     <tr className='fs-14 f-700 space color-row1' key={props.orderId}>
    //       <td><div className='border-x'>
    //           <div class="order-id">{props.orderId}</div>
    //           </div></td>
    //       <td className=' w-10'> </td>
    //       <td> 
    //       <div className='border-x'>
    //           <img   onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" />
    //           </div>
    //         </td>
    //       <td className='fs-13'><a>Product not available</a></td>
    //       <td><i className="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</td>
    //       <td></td>
    //       <td></td>
    //       <td></td>
    //       {/* Button for download */}
    //       <td> </td>

    //     </tr>
    //     {packageData?<PackageDetailsModal show={showPackageDetails} handleClose={()=>{setShowPackageDetails(false)}} data={packageData}  />:""}
    //   </>
    // )
    return false;
  }
  else if (props.from === "rto") {
    if (props?.invoices?.[0] && props?.invoices?.[0].rStatus === "RTO-Delivered" || props?.status === "Partially delivered/RTO") {
      const rtoTrack = props?.invoices?.find(item => item?.rStatus === "RTO-Delivered");
      let str_mailsentdate
      if (rtoTrack) {
        let notRepDate = new Date(rtoTrack?.transitDetail[rtoTrack?.transitDetail.length - 1].timestamp);
        let notDt = notRepDate.toUTCString(rtoTrack?.transitDetail[rtoTrack?.transitDetail.length - 1].timestamp);
        let reportCloseD = notRepDate;
        let str_rtoondate = notDt.substr(4, 12);
        let tDDate = new Date();
        var diffDate = tDDate.getTime() - notRepDate.getTime();
        reportCloseD.setDate(notRepDate.getDate() + 4)
        var closeDt = reportCloseD.toUTCString(reportCloseD);
        var daydiffer = diffDate / (1000 * 60 * 60 * 24);
        if (props.pro.rtoReportMailSentDate) {
          let dt = new Date(props.pro.rtoReportMailSentDate);
          let d = dt.toUTCString(props.pro.rtoReportMailSentDate);

          let reportCloseDate = dt;
          str_mailsentdate = d.substr(4, 12)
        }
        let rtoTransitDetail = [];
        if (rtoTrack && rtoTrack?.transitDetail) {
          rtoTransitDetail = rtoTrack.transitDetail;
          var rtodeliverdtimest = new Date(rtoTransitDetail[rtoTransitDetail.length - 1].timestamp);
          rtodeliverdtimest = rtodeliverdtimest.toDateString(rtoTrack.transitDetail[rtoTransitDetail.length - 1].timestamp);
          var rtodeliverdDate = rtodeliverdtimest.substr(4)
        }
        var reportType = undefined
        if (props.pro && props.pro.rtoReportType) {
          reportType = props.pro.rtoReportType
        }
        var btnReport;
        var RtoOptions = {
          "1": "Report to Toolsvilla",
          "2": "Time Expired",
          "3": "Already reported"
        }
        if (reportType !== undefined) {
          btnReport = "3"
        }
        else if (daydiffer > 2) {
          btnReport = "2"
        }
        else {
          btnReport = "1"
        }
        console.log(`RTO Delievered :: reportType - ${reportType} | daydiffer - ${daydiffer} | btnReport - ${btnReport}`)
        let rtoReportIdUpdated
        if (props.rtoReportId) {
          let dt = new Date(props.rtoReportId.updatedAt);
          rtoReportIdUpdated = dt.toLocaleString();
          // rtoReportIdUpdated = d.substr(4, 12);
        }

        return (
          <>
            <tr className='fs-14 f-700 color-row5 ord_table_row'>
              <td className='order_table_date'><div className='border-x'>
                <div class="order-id">{props.orderId}</div>
                <div className='order-date'>{props.date}</div>
              </div>
              </td>
              {/* <td className='order_table_date'> {props?.invoices?.[0] && props?.invoices?.[0].rStatus === "RTO-Delivered" && props?.invoices?.[0].transitDetail ? <><span className='fs-10 revoke_ord_sta_nd'>Delivered on : </span><br></br><span className=' revoke_ord_sta_nd'>{rtodeliverdDate}</span></> : <></>}</td> */}
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}

                </div>
              </td>
              <td>{props?.invoices?.[0] && props?.invoices?.[0].rStatus ?
                <div>
                  <span>RTO-Delivered</span><br />
                  <span className='order_table_date'>{rtoTrack && rtoTrack?.rStatus === "RTO-Delivered" && rtoTransitDetail? <><span className=' revoke_ord_sta_nd'>{rtodeliverdDate}</span></> : <></>}</span>
                </div> : <></>
              }
              </td>
              <td>
                <div className='border-x'>
                  {props?.invoices && props?.invoices?.length > 0 ?
                    props?.invoices.map((item, index) => {
                      if (props?.invoices?.length > 2) {
                        if (index < 2) {
                          return (
                            <div className=''>
                                <div className=''>
                                    <span className='fs-10 f-500'>
                                      Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
                                    </span>
                                    <br/>
                                    <span className='fs-10'>
                                      Courier- <strong>{item.shippingBy}</strong>
                                    </span>
                                    <br/>
                                    <span className='fs-10 f-500'>
                                      Package {index + 1}
                                    </span>
                                  </div>
                              <div className='m-auto'>
                                {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                    <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                      <button className='track_btn'>Track</button>
                                    </a>
                                  ) : (
                                    <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                      <button className='track_btn'>Track</button>
                                    </a>
                                  )}

                              </div>
                            </div>
                          )
                        }
                        else {
                          if (!showMore) {
                            if (index === 2) {
                              return (
                                <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                              )
                            }
                          }
                          else {
                            return (
                              <div className=''>
                                <div className=''>
                                   <span className='fs-10 f-500'>
      Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
    </span>
    <br/>
    <span className='fs-10'>
      Courier- <strong>{item.shippingBy}</strong>
    </span>
    <br/>
    <span className='fs-10 f-500'>
      Package {index + 1}
    </span>
                                 
                                </div>
                                <div className='m-auto'>
                                  {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                      <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                        <button className='track_btn'>Track</button>
                                      </a>
                                    ) : (
                                      <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                        <button className='track_btn'>Track</button>
                                      </a>
                                    )}

                                </div>
                              </div>
                            )
                          }
                        }
                      }
                      else {
                        return (
                          <div className=''>
                            <div className=''>
                               <span className='fs-10 f-500'>
      Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
    </span>
    <br/>
    <span className='fs-10'>
      Courier- <strong>{item.shippingBy}</strong>
    </span>
    <br/>
    <span className='fs-10 f-500'>
      Package {index + 1}
    </span>
                              
                            </div>
                            <div className='m-auto'>
                              {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                  <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                    <button className='track_btn'>Track</button>
                                  </a>
                                ) : (
                                  <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                    <button className='track_btn'>Track</button>
                                  </a>
                                )}

                            </div>
                          </div>
                        )
                      }
                    })
                    : <></>}
                </div>
              </td>
              {/* <td>{props.nicknameAdd}</td> */}
              <td>
                {props?.invoices?.[0] ?
                  props?.invoices?.[0].return_ ?

                    <span className='tool_colr f-300'><span className='tool_colr '>{props?.invoices?.[0].return_.return_add}</span>
                      <br></br>
                      {/* {props.nicknameAdd ? <><span className='text-secondary fs-11'>&#x3c;{props.nicknameAdd}&#x3e;</span></> : ""}; */}
                    </span> :
                    <span className='tool_colr f-300'><span className='tool_colr '>{props?.invoices?.[0].vendorName}</span>
                      <br></br>
                      {/* {props.nicknameAdd ? <><span className='text-secondary fs-11'>&#x3c;{props.nicknameAdd}&#x3e;</span></> : ""} */}
                    </span>

                  : <></>
                }
                <br></br>
                
                  <button className={`report_btn_rto ${btnReport === "1" ? "text-danger" : "text-black"}`} onClick={() => props.handleReportRto(props.id)}>{RtoOptions[btnReport]}</button>
              </td>

              <td>{props?.invoices?.[0] && props?.invoices?.[0].rStatus ?
                <div>
                  {props.rtoReportId && props.rtoReportId.reason === "Claim Rejected by logistics" ?
                    <span className='order_table_date'>{props.rtoReportId && props.rtoReportId.reason} ({props.rtoReportId && props.rtoReportId.agentComment})</span>
                    : <span className='order_table_date'>{props.rtoReportId && props.rtoReportId.reason} </span>
                  }
                  <br />
                  <span className='order_table_date'>{rtoReportIdUpdated}</span>
                </div> : <></>
              }
              </td>

              <td>
                <textarea placeholder='Add note here...' className='note_rto_delivered_card' id={props.id + "notesRto"}></textarea>
                <button className='add_note_btn' onClick={() => addNote(props.id + "notesRto", props.lead)}> + Add note</button>
                <i className="bi bi-info-circle ms-1" onClick={() => props.showSellerNoteModal(props.id)}></i>
              </td>
            </tr>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
      else {
        return (
          <>
            <tr className='fs-14 f-700 color-row5 ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                        <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'> {props?.invoices?.[0] && props?.invoices?.[0].rStatus === "RTO-Delivered" && props?.invoices?.[0].transitDetail ? <><span className='fs-10 revoke_ord_sta_nd'>Delivered on : </span><br></br><span className=' revoke_ord_sta_nd'>{rtodeliverdDate}</span></> : <></>}</td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}

                </div>
              </td>
              <td>{props?.invoices?.[0] && props?.invoices?.[0].rStatus ?
                <span className={props?.invoices?.[0].rStatus === "RTO-Delivered" ? 'revoke_ord_status' : 'revoke_ord_sta_nd'}>{props?.invoices?.[0].rStatus}</span> : <></>
              }
              </td>
              {/* <td>{props.nicknameAdd}</td> */}
              <td className='text-danger'>
                No details available
              </td>

              <td>
                {props?.invoices?.[0] ?
                  props?.invoices?.[0].return_ ?
                    <span className='ff_pop'><span className='tool_colr '>{props?.invoices?.[0].return_.return_add}</span></span> :
                    <span className='ff_pop'><span className='tool_colr '>{props?.invoices?.[0].vendorName}</span></span>
                  : <></>
                }
                <br></br>

              </td>


            </tr>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
    }
    else {
      if (props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0].transitDetail && props?.invoices?.[0].transitDetail.length > 0) {
        return (
          <>
            <tr className='fs-14 f-700 color-row5 ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.OrderDate}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                </div>
              </td>
              <td>{props?.invoices?.[0] && props?.invoices?.[0].rStatus ?
                <span className={props?.invoices?.[0].rStatus === "RTO-Delivered" ? 'revoke_ord_status' : 'revoke_ord_sta_nd'}>{props?.invoices?.[0].rStatus}</span> : <></>
              }
              </td>
              {/* <td>{props.nicknameAdd}</td> */}
              <td className=''>
                <div className='border-x'>
                  {props?.invoices && props?.invoices?.length > 0 ?
                    props?.invoices.map((item, index) => {
                      if (props?.invoices?.length > 2) {
                        if (index < 2) {
                          return (
                            <div className=''>
                              <div className=''>
                                 <span className='fs-10 f-500'>
                                    Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
                                  </span>
                                  <br/>
                                  <span className='fs-10'>
                                    Courier- <strong>{item.shippingBy}</strong>
                                  </span>
                                  <br/>
                                  <span className='fs-10 f-500'>
                                    Package {index + 1}
                                  </span>
                              </div>
                              <div className='m-auto'>
                                {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                  <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                    <button className='track_btn'>Track</button>
                                  </a>
                                ) : (
                                  <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                    <button className='track_btn'>Track</button>
                                  </a>
                                )}

                              </div>
                            </div>
                          )
                        }
                        else {
                          if (!showMore) {
                            if (index === 2) {
                              return (
                                <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                              )
                            }
                          }
                          else {
                            return (
                              <div className=''>
                                <div className=''>
                                   <span className='fs-10 f-500'>
                                        Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
                                      </span>
                                      <br/>
                                      <span className='fs-10'>
                                        Courier- <strong>{item.shippingBy}</strong>
                                      </span>
                                      <br/>
                                      <span className='fs-10 f-500'>
                                        Package {index + 1}
                                      </span>
                                </div>
                                <div className='m-auto'>
                                  {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                        <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                          <button className='track_btn'>Track</button>
                                        </a>
                                      ) : (
                                        <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                          <button className='track_btn'>Track</button>
                                        </a>
                                      )}

                                </div>
                              </div>
                            )
                          }
                        }
                      }
                      else {
                        return (
                          <div className=''>
                            <div className=''>
                               <span className='fs-10 f-500'>
      Docket-<strong style={{color:'#0099a8'}}>{item.docketNo}</strong>
    </span>
    <br/>
    <span className='fs-10'>
      Courier- <strong>{item.shippingBy}</strong>
    </span>
    <br/>
    <span className='fs-10 f-500'>
      Package {index + 1}
    </span>
                             
                            </div>
                            <div className='m-auto'>
                              {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                  <button className='track_btn'>Track</button>
                                </a>
                              ) : (
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>
                              )}

                            </div>
                          </div>
                        )
                      }
                    })
                    : <></>}
                </div>
              </td>

              <td>
                {props?.invoices?.[0] ?
                  props?.invoices?.[0].return_ ?
                    <span className='tool_colr f-300'><span className='tool_colr '>{props?.invoices?.[0].return_.return_add}</span>
                      <br></br>
                      {props.nicknameAdd ? <><span className='text-secondary fs-11'>&#x3c;{props.nicknameAdd}&#x3e;</span></> : ""}
                    </span> :
                    <span className='tool_colr f-300'><span className='tool_colr '>{props?.invoices?.[0].vendorName}</span>
                      <br></br>
                      {props.nicknameAdd ? <><span className='text-secondary fs-11'>&#x3c;{props.nicknameAdd}&#x3e;</span></> : ""}
                    </span>
                  : <></>
                }
                <br></br>

              </td>


            </tr>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
      else {
        return (
          <>
            <tr className='fs-14 f-700 color-row5 ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.OrderDate}</div>
                </div>
              </td>
              <td className='order_table_date'><div className='border-x'>{props.date}</div></td>
              <td className='td-img-cntn'> <div className='border-x'><img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></div></td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}

                </div>
              </td>
              <td>
                <div className='border-x'>
                  {props?.invoices?.[0] && props?.invoices?.[0].rStatus ?
                    <span className={props?.invoices?.[0].rStatus === "RTO-Delivered" ? 'revoke_ord_status' : 'revoke_ord_sta_nd'}>{props?.invoices?.[0].rStatus}</span> : <></>
                  }
                </div>
              </td>
              {/* <td>{props.nicknameAdd}</td> */}
              <td className='text-danger'>
                <div className='border-x'>
                  No details available
                </div>
              </td>

              <td>
                <div className='border-x'>
                  {props?.invoices?.[0] ?
                    props?.invoices?.[0].return_ ?
                      <span className='ff_pop'><span className='tool_colr '>{props?.invoices?.[0].return_.return_add}</span></span> :
                      <span className='ff_pop'><span className='tool_colr '>{props?.invoices?.[0].vendorName}</span></span>
                    : <></>
                  }
                </div>

              </td>


            </tr>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
    }
  }
  else if(props.status === "Pickup Pending"){
    if (props.revokes && props.revokes.length > 0) {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }

      var popover = {};
      let revokeReas;
      let res = 0;
      let dNo = [];
      let reason;
      for (let i = 0; i < props.revokes.length; i++) {
        if (props.vendor === props.revokes[i].vendor) {
          res = 1;
          dNo.push(props.revokes[i].docketNo);
          reason = props.revokes[i].revoke;

        }
      }

      // if product reassigned
      if (res === 1) {
        switch (reason) {
          case 1:
            revokeReas = "Seller Issue";
            break;
          case 2:
            revokeReas = "Courier Issue";
            break;
          case 3:
            revokeReas = "Backend Issue";
            break;
          case 4:
            revokeReas = "Improper response";
            break;
          case 5:
            revokeReas = "Customer Cancellation";
            break;
          default:
            revokeReas = "";
            break;
        }
        popover[props.id] = (
          <Popover id="popover-basic">
            <Popover.Header as="h3">Cancelled Docket</Popover.Header>
            <Popover.Body>
              <p><p>
                <strong className='ff_pop'> Previous docket No</strong></p>
                {dNo.length > 0 && dNo.map((item, index) => {
                  if (index !== dNo.length - 1) {
                    return (
                      <span className='ff_pop'>{item},</span>
                    )
                  }
                  else {
                    return (
                      <span className='ff_pop'>{item}</span>
                    )
                  }


                })}

              </p>
              <p> <strong className='ff_pop'>Reason</strong> {revokeReas}</p>
            </Popover.Body>
          </Popover>
        );
        return (
          <>
            <tr className='fs-14 f-700 ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                        <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className="order_table_price">
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>

                  {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
              {stateData?.addresses?.data?.length > 0 && (
                <td>
                  <div className='border-x'>
                    <div className='order-ad'>{props.nicknameAdd}</div>
                  </div>
                </td>
              )}
              <td>
                {/* {props?.invoices?.length > 1 ? <>{props?.invoices?.length || 0}h  <OverlayTrigger
                key={props.id}
                rootClose
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>This product will be dispatched in {props?.invoices?.length || 0}h packages</p>
                     <br></br> 
                    <p className='order_page_tooltip_2'> Details mentioned in packing slip</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger></> : props.invoices.length} */}
                <div className='border-x'>
                  <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length}</div>
                </div>
              </td>
              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
              <td><div className='border-x'>{props?.invoices?.[0]?.shippingBy}</div></td>
              <td className='text-center'>
                <div className='border-x'>
                  {/* Self-Ship Product Handling */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) ? (
                    <>

                      {props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0]?.docketNo ? (

                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Download Manifest <img src="/note.webp" />
                        </button>

                      ) : (
                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Generate Manifest
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                       <>
                      {props?.invoices && (
                        <>
                         <span className="icon-but" id={props.lead + index} 
                           onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
                           >
                            Download Manifest
                          </span>
                          <button className="download_manifest_btn_orders icon-but" id={"gen_pickup_re_btn" + props.lead + index}
                            disabled={generatingManifest}
                            onClick={() => generateManifest(props.orderMainId, props.lead, "gen_pickup_re_btn" + props.lead + index)}>
                            {generatingManifest ? "Generating Pickup Request..." : <><i className="bi bi-truck"></i> Generate Pickup Request</>}
                          </button>
                        </>
                      )}
                    </>
                      <p className='text-center ff_pop mt-1'>Reassigned</p>
                      <p className='text-black fs-11 ff_pop'>Cancelled Docket(s):- </p>
                      <p className='text-black fs-11 ff_pop cancelled_dockets_cntn'>(
                        {dNo.length > 0 && dNo.map((item, index) => {
                          if (index !== dNo.length - 1) {
                            return <><span><del>{item}</del></span>,</>
                          } else {
                            return <><span><del>{item}</del></span></>
                          }
                        })}
                        )</p>

                    </>
                  )}

                  <p onClick={() => getSellerInvoice(props?.orderMainId, props?.orderId)} className='donwload-invoice-text'>
                    <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                  </p>
                </div>
              </td>
            </tr>
            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
      else {
        return (
          <>
            <tr className='fs-14 f-700 ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                        <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className='order_table_price'>
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>

                  {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
              {stateData?.addresses?.data?.length > 0 && <td>
                <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>
              </td>}
              <td><div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div></td>



              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
              <td>
                <div className='border-x'>
                  {/* Self-Ship Product Handling */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) ? (
                    <>

                      {props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0]?.docketNo ? (

                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Download Manifest <img src="/note.webp" />
                        </button>
                      ) : (
                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Generate Manifest
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {props?.invoices && (
                        <>
                         <span className="icon-but" id={props.lead + index} 
                           onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
                           >
                            Download Manifest
                          </span>
                          <button className="download_manifest_btn_orders icon-but" id={"gen_pickup_re_btn" + props.lead + index}
                            disabled={generatingManifest}
                            onClick={() => generateManifest(props.orderMainId, props.lead, "gen_pickup_re_btn" + props.lead + index)}>
                            {generatingManifest ? "Generating Pickup Request..." : <><i className="bi bi-truck"></i> Generate Pickup Request</>}
                          </button>
                        </>
                      )}
                    </>
                  )}
                  <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                    <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                  </p>

                </div>
              </td>
            </tr>
            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
    }
    else {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }
      return (
        <>
          <tr className='fs-14 f-700 ord_table_row'>
            <td className='order_table_date'>
              <div className='border-x'>
                {/* Self-Ship Tag in first TD */}
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) && (
                    <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                      <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                    </div>
                  )}
                <div class="order-id">{props.orderId}</div>
                <div className='order-date'>{props.date}</div>
              </div>
            </td>
            <td className='order_table_date'>
              <div className='border-x'>
                <div className='order-date'>{props.updatedAt}</div>
              </div>
            </td>
            <td className='td-img-cntn'>
              <div className='border-x'>
                <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
              </div>
            </td>
            <td className='fs-13 order_table_pname_cntn'>
              <div className='border-x inline-initial'>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                <div className='order_table_sku'>SKU:- {props.sku}</div>
                <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                <ul className="d-flex ord-crd mb-0">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}
                </ul>
              </div>
            </td>
            <td className='order_table_price'>
              <div className='border-x'>
                <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                <div className='prod-gst'>{props?.taxClass ? (
                  <>
                    (incl. <strong>{props.taxClass}%</strong> GST)
                  </>
                ) : (
                  "GST missing"
                )}</div>

                {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              </div>
            </td>
            {stateData?.addresses?.data?.length > 0 && <td>
              <div className='border-x'>
                <div className='order-ad'>{props.nicknameAdd}</div>
              </div>
            </td>}
            <td>
              <div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div>
            </td>
            {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
            <td><div className='border-x'>{props?.invoices?.[0]?.shippingBy}</div></td>
            <td>
              <div className='border-x'>

                {/* Self-Ship Product Handling */}
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) ? (

                      // Self-Ship in Ready to Ship - Always show Track button
                      <>
                        {props?.invoices && props?.invoices?.length > 0 && props?.invoices.map((item, index) => (
                          <div key={index}>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div>
                                <span>Docket-</span>
                                <strong>{item.docketNo}</strong>
                                <br />
                                <span>Courier- <strong>{item.shippingBy || 'Self-Ship'}</strong></span>
                              </div>
                          <div className='m-auto'>
                            {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                              <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                <button className='track_btn'>Track</button>
                              </a>
                            ) : (
                              <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                <button className='track_btn'>Track</button>
                              </a>
                            )}
                          </div>    
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {props?.invoices && (
                      <>
                       <>
                          <span className="icon-but" id={props.lead + index} 
                           onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
                           >
                            Download Manifest
                          </span>
                        </>
                        <button className="download_manifest_btn_orders icon-but" id={"gen_pickup_re_btn" + props.lead + index}
                        disabled={generatingManifest}
                        onClick={()=>generateManifest(props.orderMainId,props.lead, "gen_pickup_re_btn" + props.lead + index)}>
                         {generatingManifest ? "Generating Pickup Request..." : <><i className="bi bi-truck"></i> Generate Pickup Request</>}
                        </button>
                      </>
                    )}
                    <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                      <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                    </p>
                  </>
                )}
              </div>
            </td>
          </tr>
          <Modal
            show={confirmationState}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHiding}
              selectedId={selectedenquiry}
              msg={msgConfirmation}
              responseconfirmationFun={responseConfirmationOrderHist}
            />
          </Modal>
          {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          <OrderSelfship
            show={showSelfShipModal}
            handleClose={handleCloseSelfShipModal}
            orderData={selectedSelfShipOrder}
            onSubmit={handleSelfShipSubmit}
          />
        </>
      )
    }
  }
  else if (props.status === "ASSIGN") {
    const renderPackageHelperBtns = () => {
      return (
        <div className='order_weight_edit_modal_btn'>
          {viewOnlyPackageEdit && <button  style={{ background: 'rgb(22, 91, 91)' }} onClick={() => setViewOnlyPackageEdit(false)}>Edit Packages</button>}
          {viewOnlyPackageEdit && <button style={{ background: "rgb(144, 144, 144)" }} onClick={() => {
            handleProceedManifestDwnld()
          }}>Proceed to Download Manifest <i className="bi bi-arrow-right"></i></button>}
        </div>
      )
    }
    if (props.revokes && props.revokes.length > 0) {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }

      var popover = {};
      let revokeReas;
      let res = 0;
      let dNo = [];
      let reason;
      for (let i = 0; i < props.revokes.length; i++) {
        if (props.vendor === props.revokes[i].vendor) {
          res = 1;
          dNo.push(props.revokes[i].docketNo);
          reason = props.revokes[i].revoke;

        }
      }

      // if product reassigned
      if (res === 1) {
        switch (reason) {
          case 1:
            revokeReas = "Seller Issue";
            break;
          case 2:
            revokeReas = "Courier Issue";
            break;
          case 3:
            revokeReas = "Backend Issue";
            break;
          case 4:
            revokeReas = "Improper response";
            break;
          case 5:
            revokeReas = "Customer Cancellation";
            break;
          default:
            revokeReas = "";
            break;
        }
        popover[props.id] = (
          <Popover id="popover-basic">
            <Popover.Header as="h3">Cancelled Docket</Popover.Header>
            <Popover.Body>
              <p><p><strong>Previous docket No</strong></p>
                {dNo.length > 0 && dNo.map((item, index) => {
                  if (index !== dNo.length - 1) {
                    return (
                      <span className=''>{item},</span>
                    )
                  }
                  else {
                    return (
                      <span className=''>{item}</span>
                    )
                  }


                })}
              </p>
              <p> <strong>Reason</strong> {revokeReas}</p>
            </Popover.Body>
          </Popover>
        );
        return (
          <>
            <tr className='fs-14 f-700 color-row ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {/* Self-Ship Tag - Show above Order ID */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{
                        display: 'inline-block',
                        marginBottom: '4px'
                      }}>
                        <span className="badge" style={{
                          backgroundColor: '#ff9800',
                          color: '#fff',
                          fontSize: '10px',
                          fontWeight: '600',
                          padding: '2px 8px',
                          borderRadius: '3px',
                          textTransform: 'uppercase'
                        }}>
                          Self-Ship
                        </span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i " />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className="order_table_price">
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>
                  {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
             { props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 &&  <td>
                <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>
              </td>}
              {/* SL-1218 */}
              { props.compo === "allOrders" && <td>
                {stateData?.addresses?.data?.length > 0 &&  <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>}
              </td>}
              <td>
                <div className='border-x'>
                  <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
                </div>
              </td>
              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal}  {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>} </div></div></td>}

              {props.compo === "allOrders" && <><td></td></>}
              <td className='text-center'>

                {/* Button for assign */}

<div className='border-x'>
  {/* DEBUG LOG - REMOVE AFTER TESTING */}
  {console.log('🔍 ORDER DEBUG (Location 1 - ASSIGN with revokes):', {
    orderId: props.orderId,
    type: props.type,
    status: props.status,
    selfShip: props.product?.selfShip,
    isSelfShip: (props.product?.selfShip === true || 
                 props.order?.products?.[0]?.productId?.selfShip === true)
  })}

  {/* Verification Icons - Only for NON-SELF-SHIP products AND New Orders */}
  {props.type === "New-Orders" && 
   (props.product?.selfShip !== true && 
    props.order?.products?.[0]?.productId?.selfShip !== true) && (
    <div style={styles.iconsContain.container}>
      <div style={styles.iconsContain.iconParent}>
        <img 
          style={styles.iconsContain.icon} 
          onClick={() => props.manifestDetailsVerify(props.id)} 
          src={props?.isPriceReq ? tpNotVerifiedIcon : tpVerifiedIcon} 
        />
      </div>
      <div style={styles.iconsContain.iconParent}>
        <img 
          style={styles.iconsContain.icon} 
          onClick={() => props.manifestDetailsVerify(props.id)} 
          src={!props?.isWeightVerified ? pkgNotVerifiedIcon : pkgVerifiedIcon} 
        />
      </div>
      <div style={styles.iconsContain.iconParent}>
        <img 
          style={styles.iconsContain.icon} 
          onClick={() => props.manifestDetailsVerify(props.id)} 
          src={props?.stock && props?.stock > 0 ? stockVerifiedIcon : stockNotVerifiedIcon} 
        />
      </div>
    </div>
  )}

  {renderManifestActionButon()}

  {/* Reassign & Cancelled Dockets */}
  <p className='text-center ff_pop mt-1'>Reassigned</p>
  <p className='text-black fs-11 ff_pop'>Cancelled Docket(s):- </p>
  <p className='text-black fs-11 ff_pop cancelled_dockets_cntn'>(
    {dNo.length > 0 && dNo.map((item, index) => (
      index !== dNo.length - 1 ? <><del>{item}</del>,</> : <><del>{item}</del></>
    ))}
  )</p>

  {/* Self-SHIP Button for View Details I1-3260 */}
  {(props.product?.selfShip === true && (
    <>
      {renderCustomerContactModal(props.order?.shippingAddress?.phoneNumber, props.order?.paymentMethod)}
      <button 
        className="download_manifest_btn_orders mni-under-process viewContact" 
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowOrderDetailsModal(true);
        }}
        type="button"
      >
        <img src="/view-icon.webp" />View Details 
      </button>
    </>
  ))}

</div>

      {/* Modal */}
      <PackageDetailsModal
        show={showModal}
        handleClose={handleCloseModal}
        data={modalData}
      />
              </td>
            </tr>

            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>

            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
        
            <OrderSelfship
              show={showSelfShipModal}
              handleClose={handleCloseSelfShipModal}
              orderData={selectedSelfShipOrder}
              onSubmit={handleSelfShipSubmit}
            />

            {renderGstConfirmModal()}
              {showPackageDetailsPopup && packageDetailsData && (
                        <CheckPopup
                          show={showPackageDetailsPopup}
                          onClose={handlePackageDetailsCancellation}
                          orderData={packageDetailsData}
                          onConfirm={handleNewManifestConfirmation}
                          onReport={handleReportWrongProduct}
                          onShowDetails={handleShowProductDetails}
                        />
                      )}
                <Modal
              show={showPackageModalForEditing}
              size="lg"
              className='updtProPopModal orderManVerModal'
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <Modal.Body className="updtProPopModal_body">
                <a class="close mt-1" onClick={() => {
                  handleProceedManifestCancel()
                }}>
                  &times;
                </a>
                <WeightComponent
                  viewOnly={viewOnlyPackageEdit}
                  handleSubmit={handleVerPackageSubmission}
                />
                {renderPackageHelperBtns()}
              </Modal.Body>
            </Modal>

          </>
        )
      }
      else {
        return (
          <>
            <tr className='fs-14 f-700 color-row ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {/* Self-Ship Tag - Show above Order ID */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{
                        display: 'inline-block',
                        marginBottom: '4px'
                      }}>
                        <span className="badge" style={{
                          backgroundColor: '#ff9800',
                          color: '#fff',
                          fontSize: '10px',
                          fontWeight: '600',
                          padding: '2px 8px',
                          borderRadius: '3px',
                          textTransform: 'uppercase'
                        }}>
                          Self-Ship
                        </span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className='order_table_price'>
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>

                  {/** Platform Fee Ticket : SL-662 & I1-2262*/}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
             {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && (
              <td>
                <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>
              </td>
            )}
              { props.compo === "allOrders" && <td>
                {stateData?.addresses?.data?.length > 0 &&  <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>}
              </td>}

              <td>
                <div className='border-x'>
                  {<div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>}
                </div>
              </td>



              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>} </div></div></td>}
              {props.compo === "allOrders" && <><td></td></>}
              <td>
                <div className='border-x'>
                  {console.log('🔍 ORDER DEBUG (Location 2):', {
                    orderId: props.orderId,
                    type: props.type,
                    isSelfShip: (props.product?.selfShip === true ||
                      props.order?.products?.[0]?.productId?.selfShip === true)
                  })}

                  {/* Verification Icons */}
                  {props.type === "New-Orders" && (
                    (props.product?.selfShip !== true &&
                      props.order?.products?.[0]?.productId?.selfShip !== true) ? (
                      <div style={styles.iconsContain.container}>
                        <div style={styles.iconsContain.iconParent}>
                          <img
                            style={styles.iconsContain.icon}
                            onClick={() => props.manifestDetailsVerify(props.id)}
                            src={props?.isPriceReq ? tpNotVerifiedIcon : tpVerifiedIcon}
                          />
                        </div>
                        <div style={styles.iconsContain.iconParent}>
                          <img
                            style={styles.iconsContain.icon}
                            onClick={() => props.manifestDetailsVerify(props.id)}
                            src={!props?.isWeightVerified ? pkgNotVerifiedIcon : pkgVerifiedIcon}
                          />
                        </div>
                        <div style={styles.iconsContain.iconParent}>
                          <img
                            style={styles.iconsContain.icon}
                            onClick={() => props.manifestDetailsVerify(props.id)}
                            src={props?.stock && props?.stock > 0 ? stockVerifiedIcon : stockNotVerifiedIcon}
                          />
                        </div>
                      </div>
                    ) : null
                  )}

                  {renderManifestActionButon()}
                  <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                    <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                  </p>

                  {/* Self-SHIP Button for View Details I1-3260 */}
                  {(props.product?.selfShip === true && (
                    <>
                      {renderCustomerContactModal(props.order?.shippingAddress?.phoneNumber, props.order?.paymentMethod)}
                      <button 
                        className="download_manifest_btn_orders mni-under-process viewContact" 
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowOrderDetailsModal(true);
                        }}
                        type="button"
                      >
                        <img src="/view-icon.webp" />View Details 
                      </button>
                    </>
                  ))}

                </div>
              </td>

            </tr>
            {/* Confirmation Modal */}
                 

            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}    
            <OrderSelfship
              show={showSelfShipModal}
              handleClose={handleCloseSelfShipModal}
              orderData={selectedSelfShipOrder}
              onSubmit={handleSelfShipSubmit}
            />
            {renderGstConfirmModal()}
            <Modal
              show={showPackageModalForEditing}
              size="lg"
              className='updtProPopModal orderManVerModal'
              aria-labelledby="contained-modal-title-vcenter"
              centered>
                <Modal.Body className="updtProPopModal_body">
                  <a class="close mt-1" onClick={() => {
                    handleProceedManifestCancel()
                  }}>
                    &times;
                  </a>
                  <WeightComponent
                    viewOnly={viewOnlyPackageEdit}
                    handleSubmit={handleVerPackageSubmission}
                  />
                  {renderPackageHelperBtns()}
                </Modal.Body>
            </Modal>
                 {showPackageDetailsPopup && packageDetailsData && (
                        <CheckPopup
                          show={showPackageDetailsPopup}
                          onClose={handlePackageDetailsCancellation}
                          orderData={packageDetailsData}
                          onConfirm={handleNewManifestConfirmation}
                          onReport={handleReportWrongProduct}
                          onShowDetails={handleShowProductDetails}
                        />
            )}
          </>
        )
      }
    }
    else {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }
      return (
        <>
          <tr className='fs-14 f-700 color-row ord_table_row'>
            <td className='order_table_date'>
              <div className='border-x'>
                {/* Self-Ship Tag - Show above Order ID */}
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) && (
                    <div className="self-ship-tag mb-1" style={{
                      display: 'inline-block',
                      marginBottom: '4px'
                    }}>
                      <span className="badge" style={{
                        backgroundColor: '#ff9800',
                        color: '#fff',
                        fontSize: '10px',
                        fontWeight: '600',
                        padding: '2px 8px',
                        borderRadius: '3px',
                        textTransform: 'uppercase'
                      }}>
                        Self-Ship
                      </span>
                    </div>
                  )}
                <div class="order-id">{props.orderId}</div>
                <div className='order-date'>{props.date}</div>
              </div>
            </td>
            <td className='order_table_date'>
              <div className='border-x'>
                <div className='order-date'>{props.updatedAt}</div>
              </div>
            </td>
            <td className='td-img-cntn'>
              <div className='border-x'>
                <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
              </div>
            </td>
            <td className='fs-13 order_table_pname_cntn'>
              <div className='border-x inline-initial'>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                <div className='order_table_sku'>SKU:- {props.sku}</div>
                <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                <ul className="d-flex ord-crd mb-0">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}

                </ul>
              </div>
            </td>
            <td className='order_table_price'>
              <div className='border-x'>
                <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                <div className='prod-gst'>{props?.taxClass ? (
                  <>
                    (incl. <strong>{props.taxClass}%</strong> GST)
                  </>
                ) : (
                  "GST missing"
                )}</div>

                {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
              </div>
            </td>
            {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && (
              <td>
                <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>
              </td>
            )}
            { props.compo === "allOrders" && <td>
              {stateData?.addresses?.data?.length > 0 &&  <div className='border-x'>
                <div className='order-ad'>{props.nicknameAdd}</div>
              </div>}
            </td>}
            <td>
              <div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>

              </div>
            </td>

            {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>} </div></div></td>}
              
            {props.compo === "allOrders" && <><td></td></>}
            <td className='text-center'>
              <div className='border-x'>

                {/* Verification Icons - Only for NON-SELF-SHIP and New Orders */}
                {props.type === "New-Orders" &&
                  (props.product?.selfShip !== true &&
                    props.order?.products?.[0]?.productId?.selfShip !== true) && (
                    <div style={styles.iconsContain.container}>
                      <div style={styles.iconsContain.iconParent}>
                        <img
                          style={styles.iconsContain.icon}
                          onClick={() => props.manifestDetailsVerify(props.id)}
                          src={props?.isPriceReq ? tpNotVerifiedIcon : tpVerifiedIcon}
                        />
                      </div>
                      <div style={styles.iconsContain.iconParent}>
                        <img
                          style={styles.iconsContain.icon}
                          onClick={() => props.manifestDetailsVerify(props.id)}
                          src={!props?.isWeightVerified ? pkgNotVerifiedIcon : pkgVerifiedIcon}
                        />
                      </div>
                      <div style={styles.iconsContain.iconParent}>
                        <img
                          style={styles.iconsContain.icon}
                          onClick={() => props.manifestDetailsVerify(props.id)}
                          src={props?.stock && props?.stock > 0 ? stockVerifiedIcon : stockNotVerifiedIcon}
                        />
                      </div>
                    </div>
                  )}
                {renderManifestActionButon()}

                <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                  <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                </p>

                {/* Self-SHIP Button for View Details I1-3260 */}
                {(props.product?.selfShip === true && (
                  <>
                    {renderCustomerContactModal(props.order?.shippingAddress?.phoneNumber, props.order?.paymentMethod)}
                    <button 
                      className="download_manifest_btn_orders mni-under-process viewContact" 
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowOrderDetailsModal(true);
                      }}
                      type="button"
                    >
                      <img src="/view-icon.webp" />View Details 
                    </button>
                  </>
                ))}

              </div>
            </td>
          </tr>
          {/* Confirmation Modal */}

          <Modal
            show={confirmationState}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHiding}
              selectedId={selectedenquiry}
              msg={msgConfirmation}
              responseconfirmationFun={responseConfirmationOrderHist}
            />
          </Modal>
          {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}


          <OrderSelfship
            show={showSelfShipModal}
            handleClose={handleCloseSelfShipModal}
            orderData={selectedSelfShipOrder}
            onSubmit={handleSelfShipSubmit}
          />
          {renderGstConfirmModal()}
           <Modal
            show={showPackageModalForEditing}
            size="lg"
            className='updtProPopModal orderManVerModal'
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Body className="updtProPopModal_body">
              <a class="close mt-1" onClick={() => {
                handleProceedManifestCancel()
              }}>
                &times;
              </a>
              <WeightComponent
                viewOnly={viewOnlyPackageEdit}
                handleSubmit={handleVerPackageSubmission}
              />
              {renderPackageHelperBtns()}
            </Modal.Body>
          </Modal>

          {showPackageDetailsPopup && packageDetailsData && (
                    <CheckPopup
                        show={showPackageDetailsPopup}
                        onClose={handlePackageDetailsCancellation}
                        orderData={packageDetailsData}
                        onConfirm={handleNewManifestConfirmation}
                          onReport={handleReportWrongProduct}
                          onShowDetails={handleShowProductDetails}
                      />
                  )}
        </>
      )
    }
  }
  else if (props.status === "DOWNLOAD") {
    if (props.revokes && props.revokes.length > 0) {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }

      var popover = {};
      let revokeReas;
      let res = 0;
      let dNo = [];
      let reason;
      for (let i = 0; i < props.revokes.length; i++) {
        if (props.vendor === props.revokes[i].vendor) {
          res = 1;
          dNo.push(props.revokes[i].docketNo);
          reason = props.revokes[i].revoke;

        }
      }

      // if product reassigned
      if (res === 1) {
        switch (reason) {
          case 1:
            revokeReas = "Seller Issue";
            break;
          case 2:
            revokeReas = "Courier Issue";
            break;
          case 3:
            revokeReas = "Backend Issue";
            break;
          case 4:
            revokeReas = "Improper response";
            break;
          case 5:
            revokeReas = "Customer Cancellation";
            break;
          default:
            revokeReas = "";
            break;
        }
        popover[props.id] = (
          <Popover id="popover-basic">
            <Popover.Header as="h3">Cancelled Docket</Popover.Header>
            <Popover.Body>
              <p><p>
                <strong className='ff_pop'> Previous docket No</strong></p>
                {dNo.length > 0 && dNo.map((item, index) => {
                  if (index !== dNo.length - 1) {
                    return (
                      <span className='ff_pop'>{item},</span>
                    )
                  }
                  else {
                    return (
                      <span className='ff_pop'>{item}</span>
                    )
                  }


                })}

              </p>
              <p> <strong className='ff_pop'>Reason</strong> {revokeReas}</p>
            </Popover.Body>
          </Popover>
        );
        return (
          <>
            <tr className='fs-14 f-700 color-row ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                        <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className="order_table_price">
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>

                  {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
                {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td>
                  <div className='border-x'>
                    <div className='order-ad'>{props.nicknameAdd}</div>
                  </div>
                </td>}
              {props.compo === "allOrders" && <td>
                {stateData?.addresses?.data?.length > 0 &&<div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>}
              </td>}
              <td>
                {/* {props?.invoices?.length > 1 ? <>{props?.invoices?.length || 0}h  <OverlayTrigger
                key={props.id}
                rootClose
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>This product will be dispatched in {props?.invoices?.length || 0}h packages</p>
                     <br></br> 
                    <p className='order_page_tooltip_2'> Details mentioned in packing slip</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger></> : props.invoices.length} */}
                <div className='border-x'>
                  <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length}</div>
                </div>
              </td>
              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
              
              <td><div className='border-x'>{props?.invoices?.[0]?.shippingBy}</div></td>
              <td className='text-center'>
                <div className='border-x'>
                  {/* Self-Ship Product Handling */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) ? (
                    <>

                      {props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0]?.docketNo ? (
                       
                        <button 
            className="download_manifest_btn_orders" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenSelfShipModal(props);
            }}
            type="button"
          >
            Download Manifest <img src="/note.webp" />
          </button>
          
                      ) : (
                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Generate Manifest
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {props.type === "New-Orders" && (
                        <>
                          <div style={styles.iconsContain.container}>
                            <div style={styles.iconsContain.iconParent}><img style={styles.iconsContain.icon} onClick={() => props.manifestDetailsVerify(props.id)} src={props?.isPriceReq ? tpNotVerifiedIcon : tpVerifiedIcon} /></div>
                            <div style={styles.iconsContain.iconParent}><img style={styles.iconsContain.icon} onClick={() => props.manifestDetailsVerify(props.id)} src={!props?.isWeightVerified ? pkgNotVerifiedIcon : pkgVerifiedIcon} /></div>
                            <div style={styles.iconsContain.iconParent}><img style={styles.iconsContain.icon} onClick={() => props.manifestDetailsVerify(props.id)} src={props?.stock && props?.stock > 0 ? stockVerifiedIcon : stockNotVerifiedIcon} /></div>
                          </div>
                          {props.showVerifyToGenManifest && (
                            <button className="download_manifest_btn_orders icon-but mb-1" id={props.lead + index} onClick={() => props.manifestDetailsVerify(props.id)}>
                              {props?.sellerWeightChangeSts === "V_PENDING" ? <>Download Manifest <img src="/note.webp" /></> : "Verify Details to generate manifest"}
                            </button>
                          )}
                        </>)}
                      {props?.invoices && !props.showVerifyToGenManifest && (
                        <>
                          <button className="download_manifest_btn_orders icon-but" id={props.lead + index} 
                           onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}
                           >
                            Download Manifest <img src="/note.webp" />
                          </button>
                          <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover[props.id]}>
                            <i className="bi bi-info-circle theme-col fs-15" aria-hidden="true"></i>
                          </OverlayTrigger>
                        </>
                      )}
                      <p className='text-center ff_pop mt-1'>Reassigned</p>
                      <p className='text-black fs-11 ff_pop'>Cancelled Docket(s):- </p>
                      <p className='text-black fs-11 ff_pop cancelled_dockets_cntn'>(
                        {dNo.length > 0 && dNo.map((item, index) => {
                          if (index !== dNo.length - 1) {
                            return <><span><del>{item}</del></span>,</>
                          } else {
                            return <><span><del>{item}</del></span></>
                          }
                        })}
                        )</p>

                    </>
                  )}

                  <p onClick={() => getSellerInvoice(props?.orderMainId, props?.orderId)} className='donwload-invoice-text'>
                    <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                  </p>
                </div>
              </td>
            </tr>
            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
      else {
        return (
          <>
            <tr className='fs-14 f-700 color-row ord_table_row'>
              <td className='order_table_date'>
                <div className='border-x'>
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) && (
                      <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                        <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                      </div>
                    )}
                  <div class="order-id">{props.orderId}</div>
                  <div className='order-date'>{props.date}</div>
                </div>
              </td>
              <td className='order_table_date'>
                <div className='border-x'>
                  <div className='order-date'>{props.updatedAt}</div>
                </div>
              </td>
              <td className='td-img-cntn'>
                <div className='border-x'>
                  <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
                </div>
              </td>
              <td className='fs-13 order_table_pname_cntn'>
                <div className='border-x inline-initial'>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                  <div className='order_table_sku'>SKU:- {props.sku}</div>
                  <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                  <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                  {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                  <ul className="d-flex ord-crd mb-0">
                    {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                      return (
                        <>
                          <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                        </>
                      )
                    }) : <></>}

                  </ul>
                </div>
              </td>
              <td className='order_table_price'>
                <div className='border-x'>
                  <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                  <div className='prod-gst'>{props?.taxClass ? (
                    <>
                      (incl. <strong>{props.taxClass}%</strong> GST)
                    </>
                  ) : (
                    "GST missing"
                  )}</div>

                  {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                  <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                  {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
                </div>
              </td>
              {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td>
                <div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>
              </td>}
              {props.compo === "allOrders" && <td>
                {stateData?.addresses?.data?.length > 0 &&<div className='border-x'>
                  <div className='order-ad'>{props.nicknameAdd}</div>
                </div>}
              </td>}
              <td><div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div></td>



              {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
              <td><div className='border-x'>{props?.invoices?.[0]?.shippingBy}</div></td>
              <td>
                <div className='border-x'>
                  {/* Self-Ship Product Handling */}
                  {(props.product?.selfShip === true ||
                    props.order?.products?.[0]?.productId?.selfShip === true) ? (
                    <>

                      {props?.invoices && props?.invoices?.length > 0 && props?.invoices?.[0]?.docketNo ? (
                        
                        <button 
            className="download_manifest_btn_orders" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenSelfShipModal(props);
            }}
            type="button"
          >
            Download Manifest <img src="/note.webp" />
          </button>
                      ) : (
                        <button
                          className="download_manifest_btn_orders"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOpenSelfShipModal(props);
                          }}
                          type="button"
                        >
                          Generate Manifest
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {props?.invoices && (
                        <>
                          <button className="download_manifest_btn_orders icon-but" id={props.lead + index}  onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}>
                            Download Manifest <img src="/note.webp" />
                          </button>
                          <OverlayTrigger
                            key={props.orderId}
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                                <p className='f-500 order_page_tooltip_1'>Manifest already downloaded for this order</p>
                              </Tooltip>
                            }
                          >
                            <i class="bi bi-info-circle ms-1"></i>
                          </OverlayTrigger>
                        </>
                      )}
                    </>
                  )}
                  <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                    <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                  </p>

                </div>
              </td>
            </tr>
            {/* Confirmation Modal */}
            <Modal
              show={confirmationState}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered>
              <ConfirmationModal
                onHide={confirmationBoxHiding}
                selectedId={selectedenquiry}
                msg={msgConfirmation}
                responseconfirmationFun={responseConfirmationOrderHist}
              />
            </Modal>
            {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          </>
        )
      }
    }
    else {
      let dayVal = "day"
      let orderdate = new Date(props.actualdate)
      let tDDate = new Date();
      let diffDate = tDDate.getTime() - orderdate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 1) {
        dayVal = "days"
      }
      return (
        <>
          <tr className='fs-14 f-700 color-row1 ord_table_row'>
            <td className='order_table_date'>
              <div className='border-x'>
                {/* Self-Ship Tag in first TD */}
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) && (
                    <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                      <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                    </div>
                  )}
                <div class="order-id">{props.orderId}</div>
                <div className='order-date'>{props.date}</div>
              </div>
            </td>
            <td className='order_table_date'>
              <div className='border-x'>
                <div className='order-date'>{props.updatedAt}</div>
              </div>
            </td>
            <td className='td-img-cntn'>
              <div className='border-x'>
                <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
              </div>
            </td>
            <td className='fs-13 order_table_pname_cntn'>
              <div className='border-x inline-initial'>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                <div className='order_table_sku'>SKU:- {props.sku}</div>
                <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                <ul className="d-flex ord-crd mb-0">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}
                </ul>
              </div>
            </td>
            <td className='order_table_price'>
              <div className='border-x'>
                <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                <div className='prod-gst'>{props?.taxClass ? (
                  <>
                    (incl. <strong>{props.taxClass}%</strong> GST)
                  </>
                ) : (
                  "GST missing"
                )}</div>

                {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              </div>
            </td>
            {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td>
              <div className='border-x'>
                <div className='order-ad'>{props.nicknameAdd}</div>
              </div>
            </td>}
            {props.compo === "allOrders" && <td>
              {stateData?.addresses?.data?.length > 0 &&<div className='border-x'>
                <div className='order-ad'>{props.nicknameAdd}</div>
              </div>}
            </td>}
            <td>
              <div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div>
            </td>
            {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal} {daydiffer > 3 && <><p className='apply-btn px-3 py-1 ff_Pop fs-10 breachingBtn breachingTxt'><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Breaching Soon</p><div onClick={() => props.showRaiseConcern(props.orderId)} style={{ marginTop: "5px", cursor: "pointer" }}><i class="fa fa-flag"></i> Report</div></>}</div></div></td>}
            
            <td><div className='border-x'>{props?.invoices?.[0]?.shippingBy}</div></td>
            <td>
              <div className='border-x'>

                {/* Self-Ship Product Handling */}
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) ? (

                      // Self-Ship in Ready to Ship - Always show Track button
                      <>
                        {props?.invoices && props?.invoices?.length > 0 && props?.invoices.map((item, index) => (
                          <div key={index}>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div>
                                <span>Docket-</span>
                                <strong>{item.docketNo}</strong>
                                <br />
                                <span>Courier- <strong>{item.shippingBy || 'Self-Ship'}</strong></span>
                              </div>
                          <div className='m-auto'>
                            {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                              <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                <button className='track_btn'>Track</button>
                              </a>
                            ) : (
                              <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                <button className='track_btn'>Track</button>
                              </a>
                            )}
                          </div>    
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {props?.invoices && (
                      <>
                        <button className="download_manifest_btn_orders icon-but" id={props.lead + index}  onClick={() => newDownloadManifestConfirmation(props?.invoices, props.status, props.lead, index, props.orderId, props.sku, props.orderMainId)}>
                          Download Manifest <img src="/note.webp" />
                        </button>
                        <OverlayTrigger
                          key={props.orderId}
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                              <p className='f-500 order_page_tooltip_1'>Manifest already downloaded for this order</p>
                            </Tooltip>
                          }
                        >
                          <i class="bi bi-info-circle ms-1"></i>
                        </OverlayTrigger>
                      </>
                    )}
                    <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'>
                      <i className="bi bi-file-earmark-arrow-down"></i> Download Invoice
                    </p>
                  </>
                )}
              </div>
            </td>
          </tr>
          <Modal
            show={confirmationState}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHiding}
              selectedId={selectedenquiry}
              msg={msgConfirmation}
              responseconfirmationFun={responseConfirmationOrderHist}
            />
          </Modal>
          {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
          <OrderSelfship
            show={showSelfShipModal}
            handleClose={handleCloseSelfShipModal}
            orderData={selectedSelfShipOrder}
            onSubmit={handleSelfShipSubmit}
          />
        </>
      )
    }

  }
  else if (props.status === "REVOKED") {
    let revokeReas;
    let revDockets = [];
    let tempDockets = [];
    let rvDate;
    let reason = undefined
    let orderdate = new Date(props?.order?.orderPlaceDate)
    let tDDate = new Date();
    let dayVal = "day"
    let diffDate = tDDate.getTime() - orderdate.getTime()
    let daydiffer = diffDate / (1000 * 60 * 60 * 24);
    daydiffer = Math.floor(daydiffer)
    if (daydiffer > 1) {
      dayVal = "days"
    }

    if (props?.revokeReason) {
      reason = props.revokeReason;
    }

    props.revokes && props.revokes.length > 0 && props.revokes.map((item) => {
      if (vendorId === item.vendor) {
        revDockets.push(item.docketNo)
        if (!reason) {
          reason = item?.revoke;
        }
      }
      else if (vendorId !== item.vendor && revDockets.length > 0) {
        tempDockets = revDockets
        revDockets = [];
      }
    })


    if (revDockets.length < 1) {
      revDockets = tempDockets
    }
    if (props.revokeDate) {
      rvDate = moment(props.revokeDate).format("D, MMM YYYY, h:mm:ss a");
    }
    if (props.spcl) {
      let revokeReas;

      switch (reason) {
        case 1:
          revokeReas = "Seller Issue";
          break;
        case 2:
          revokeReas = "Courier Issue";
          break;
        case 3:
          revokeReas = "Backend Issue";
          break;
        case 4:
          revokeReas = "Improper response";
          break;
        case 5:
          revokeReas = "Customer Cancellation";
          break;
        default:
          revokeReas = "";
          break;
      }

      return (
        <>
          <tr className='fs-14 f-700 color-row4 ord_table_row ord_table_row_revoked'>
            <td className='order_table_date'>
              <div className='border-x'>
                <div class="order-id">{props.orderId}</div>
              </div>
            </td>
            <td className='order_table_date'>
              <div className='border-x'>
                <div className='order-date'>{props.date}</div>
              </div>
            </td>
            <td className='td-img-cntn'>
              <div className='border-x'>
                <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
              </div>
            </td>
            <td className='fs-13 order_table_pname_cntn'>
              <div className='border-x inline-initial'>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                <div className='order_table_sku'>SKU:- {props.sku}</div>
                <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                <ul className="d-flex ord-crd mb-0">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}

                </ul>
              </div>
            </td>
            <td>
              <div className='border-x'>
                <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                <div className='prod-gst'>{props?.taxClass ? (
                  <>
                    (incl. <strong>{props.taxClass}%</strong> GST)
                  </>
                ) : (
                  "GST missing"
                )}</div>

                {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
              </div>
            </td>
            <td>
              {/* {props.nicknameAdd} */}
            </td>
            <td>
              <div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div>
            </td>
            {props.compo === "allOrders" ? <><td></td></> : <td>
              <div className='border-x'>
                {daydiffer} {dayVal}
                </div></td>
              }
            <td className='overflow_wrap'>
              <div className='border-x'>
                <span className='f-700 fs-14'>REVOKED</span><br></br>
                <div className='d-flex justify-content-around'>
                  <div>
                    {revDockets && revDockets.length > 0 && revDockets.map((item, index) => (
                      <>
                        <span style={{ "textDecoration": "line-through" }}>{item}</span>
                        {
                          index !== revDockets.length - 1 && <span>,</span>
                        }
                      </>
                    ))
                    }
                  </div>


                  <div>
                    <button className='revoke_ok_btn' onClick={() => revokeUpdt(props.lead)}>OK</button><br></br>
                  </div>
                </div>
                <span className='f-700 fs-14'>{revokeReas} {renderReasonOverlay(revokeReas)}</span>

                {props?.revokeReasonType ? <span className='fs-10'>{revokeReas === "Seller Issue" && <>({props?.revokeReasonType})</>}</span> : <></>}
                <br></br>
                <span className='fs-10'>({props.updatedAt} )</span>
                {/* {props?.compo === "Cancelled" ? <></> : <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'><i className="bi bi-file-earmark-arrow-down"></i> Download Invoice</p>} */}
              </div>

            </td>

          </tr>
          {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
        </>
      )
    }
    else {

      switch (reason) {
        case 1:
          revokeReas = "Seller Issue";
          break;
        case 2:
          revokeReas = "Courier Issue";
          break;
        case 3:
          revokeReas = "Backend Issue";
          break;
        case 4:
          revokeReas = "Improper response";
          break;
        case 5:
          revokeReas = "Customer Cancellation";
          break;
        default:
          revokeReas = "";
          break;
      }

      return (
        <>
          <tr className='fs-14 f-700 color-row4 ord_table_row ord_table_row_revoked'>
            <td className='order_table_date'>
              <div className='border-x'>
                {(props.product?.selfShip === true ||
                  props.order?.products?.[0]?.productId?.selfShip === true) && (
                    <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                      <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                    </div>
                  )}
                <div class="order-id">{props.orderId}</div>
                <div className='order-date'>{props.date}</div>
              </div>
            </td>
            <td className='order_table_date'><div className='border-x'>
              <div className='order-date'>{rvDate}</div>
            </div> </td>
            <td className='td-img-cntn'>
              <div className='border-x'>
                <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
              </div>
            </td>
            <td className='fs-13 order_table_pname_cntn'>
              <div className='border-x inline-initial'>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
                <div className='order_table_sku'>SKU:- {props.sku}</div>
                <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
                <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
                {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
                <ul className="d-flex ord-crd mb-0">
                  {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                      </>
                    )
                  }) : <></>}

                </ul>
              </div>
            </td>
            <td>
              <div className='border-x'>
                <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
                <div className='prod-gst'>{props?.taxClass ? (
                  <>
                    (incl. <strong>{props.taxClass}%</strong> GST)
                  </>
                ) : (
                  "GST missing"
                )}</div>

                {/** Platform Fee Ticket : SL-662 & I1-2262 */}
                <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
                {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
              </div>
            </td>
            <td>
              {/* {props.nicknameAdd} */}
            </td>
            <td>
              <div className='border-x'>
                <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
              </div>
            </td>
            
            {/* for alignment issue SL-1218 */}
            {props.compo === "allOrders" ? <><td></td></> : <></>}
            <td className='overflow_wrap'>
              <div className='border-x'>
                Revoked<br />

                {revDockets && revDockets.length > 0 ?
                  <p className='fs-10'>(
                    {
                      revDockets.map((item, index) => (
                        <>
                          <span style={{ "textDecoration": "line-through" }} className="fs-10">{item}</span>
                          {
                            index !== revDockets.length - 1 && <span>,</span>
                          }
                        </>

                      ))
                    }
                    )
                  </p> : <></>
                }

                {revokeReas !== "" ?
                  <>
                    <span className='fs-14 text-white px-2 py-1 bg-theme'>{revokeReas} {renderReasonOverlay(revokeReas)}</span>
                    {props?.revokeReasonType ? <span className='fs-10'>{revokeReas === "Seller Issue" && <>({props?.revokeReasonType})</>}</span> : <></>}
                  </> : <></>}

                {props?.compo === "Cancelled" ? <></> : (

                  <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'><i className="bi bi-file-earmark-arrow-down"></i> Download Invoice</p>
                )}

              </div>
            </td>

          </tr>
          {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
        </>
      )
    }

  }
  else if (props.status === "CANCEL") {
    let revokeReas;
    let revDockets = [];
    let tempDockets = [];
    let rvDate;

    props.revokes && props.revokes.length > 0 && props.revokes.map((item) => {

      if (vendorId === item.vendor) {
        revDockets.push(item.docketNo)
      }
      else if (vendorId !== item.vendor && revDockets.length > 0) {
        tempDockets = revDockets
        revDockets = [];
      }
    })

    if (revDockets.length < 1) {
      revDockets = tempDockets
    }

    if (props.revokeDate) {
      rvDate = moment(props.revokeDate).format("D, MMM YYYY, h:mm:ss a");
    }
    return (
      <>
        <tr className='fs-14 f-700 ord_table_row_revoked ord_table_row'>
          <td className='theme-col'>
            <div className='border-x'>
              {(props.product?.selfShip === true ||
                props.order?.products?.[0]?.productId?.selfShip === true) && (
                  <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                    <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                  </div>
                )}
              <div class="order-id">{props.orderId}</div>
              <div className='order-date'>{props.date}</div>
            </div>
          </td>
          <td className=' w-10'><div className='border-x'>
            <div className='order-date'>{rvDate}</div>
          </div></td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
              <ul className="d-flex ord-crd mb-0">
                {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                  return (
                    <>
                      <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                    </>
                  )
                }) : <></>}

              </ul>
            </div>
          </td>
          <td>
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>

              {/** Platform Fee Ticket : SL-662 & I1-2262 */}
              <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
            </div>
          </td>
          <td>{props.nicknameAdd}</td>

          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
            </div>
          </td>
          {props.compo === "allOrders" && <><td></td></>}
          <td className='text-dec'>
            <div className='border-x'>
              Cancelled
              {revDockets?.length > 0 && (
                <div
                  className="order-docket-ids-list"
                  title={revDockets.join(", ")}
                >
                  ({revDockets.join(", ")})
                </div>
              )}

              {props?.orderCancelReason && <span className='fs-10 text-white px-2 py-1 bg-theme'>{props.orderCancelReason}</span>}
            </div>
          </td>

        </tr>
        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
      </>
    )
  }
  else if (props.status === "PICKED") {
    return (
      <>
        <tr className='fs-14 f-700 color-row5 ord_table_row'>
          <td className='order_table_date'>
            <div className='border-x'>
              {(props.product?.selfShip === true ||
                props.order?.products?.[0]?.productId?.selfShip === true) && (
                  <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                    <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                  </div>
                )}
              <div class="order-id">{props.orderId}</div>
              <div className='order-date'>{props.date}</div>
            </div>
          </td>
          <td className='order_table_date'>
            <div className='border-x'>
              <div className='order-date'>{props.updatedAt}</div>
            </div>
          </td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
              <ul className="d-flex ord-crd mb-1">

                {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                  return (
                    <>
                      <span className="enq-card-comb-span" key={index}><span className='ff_pop'>{props.combination[index]}</span><span className='ff_pop'> : {item}</span></span>
                      {/* <li className="bg-theme  p-1 m-1 text-white fs-11 corner f_s_pop">{props.combination[index]} - {item}</li> */}
                    </>
                  )
                }) : <></>}

              </ul>
            </div>
          </td>
          <td>
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>

              {/** Platform Fee Ticket : SL-662 & I1-2262 */}
              <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
            </div>
          </td>
          {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td>
            <div className='border-x'>
              <div className='order-ad'>{props.nicknameAdd}</div>
            </div>
          </td>}
          {props.compo === "allOrders" && <td>
            {stateData?.addresses?.data?.length > 0 &&<div className='border-x'>
              <div className='order-ad'>{props.nicknameAdd}</div>
            </div>}
          </td>}
          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
            </div>
          </td>
          {props.compo === "allOrders" && 
          <>
          <td></td>
          </>

          }
          <td className=''>
            <div className='border-x'>
              {props?.invoices?.length > 0 ?
                props?.invoices.map((item, index) => {
                  if (props?.invoices?.length > 3) {
                    if (index < 3) {
                      return (
                        <>
                          {index !== 0 && <hr className='my-1'></hr>}
                          <div className='order-track'>
                            <div className=''>
                              <span className=''>
                                Docket-
                              </span>
                              <strong className=' '>{item?.docketNo}</strong>
                              <br></br>
                              <span className=''>
                                Courier- <strong>{item?.shippingBy}</strong>
                              </span>
                            </div>
                            <div className='m-auto'>
                              {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                  <button className='track_btn'>Track</button>
                                </a>
                              ) : (
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>
                              )}

                            </div>
                          </div>

                        </>
                      )
                    }
                    else {
                      if (!showMore) {
                        if (index === 3) {
                          return (
                            <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                          )
                        }
                      }
                      else {
                        return (
                          <>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div className=''>
                                <span className=''>
                                  Docket-
                                </span>
                                <strong className=' '>{item.docketNo}</strong>
                                <br></br>
                                <div className=''>
                                  Courier- <strong>{item.shippingBy}</strong>
                                </div>
                              </div>
                              <div className='m-auto'>
                                {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                      <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                        <button className='track_btn'>Track</button>
                                      </a>
                                    ) : (
                                      <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                        <button className='track_btn'>Track</button>
                                      </a>
                                    )}

                              </div>
                            </div>

                          </>
                        )
                      }
                    }
                  }
                  else {
                    return (
                      <>
                        {index !== 0 && <hr className='my-1'></hr>}
                        <div className='order-track'>
                          <div className=''>
                            <span className=''>
                              Docket-
                            </span>
                            <strong className=' '>{item.docketNo}</strong>
                            <br></br>
                            <span className=''>
                              Courier- <strong>{item.shippingBy}</strong>
                            </span>
                          </div>
                          <div className='m-auto'>
                            {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                  <button className='track_btn'>Track</button>
                                </a>
                              ) : (
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>
                              )}

                          </div>
                        </div>

                      </>
                    )
                  }
                })
                : <></>}

            </div>
          </td>

        </tr>
        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
      </>
    )
  }
  else if (props.status === "DELIVERED") {
    return (
      <>
        <tr className='fs-14 f-700 color-row5 ord_table_row'>
          <td className='order_table_date'><div className='border-x'>
            {(props.product?.selfShip === true ||
              props.order?.products?.[0]?.productId?.selfShip === true) && (
                <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                  <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                </div>
              )}
            {props.orderId}
          </div></td>
          <td className='order_table_date'><div className='border-x'>{props?.orderPlaceDate}</div></td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
            </div>
          </td>
          <td>
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>

              {/** Platform Fee Ticket : SL-662 & I1-2262 */}
              <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
            </div>

          </td>
          {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td><div className='border-x'>
            <div className='order-ad'>{props.nicknameAdd}</div>
          </div></td>}
          {props.compo === "allOrders" && <td><div className='border-x'>
            {stateData?.addresses?.data?.length > 0 &&
              <div className='order-ad'>{props.nicknameAdd}</div>
            }
          </div></td>}
          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
            </div>
            {/* {props?.invoices?.length > 1 ? <>{props?.invoices?.length || 0}h  <OverlayTrigger
            key={props.id}
            placement="bottom"

            overlay={
              <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                <p className='f-500 order_page_tooltip_1'>This product will be dispatched in {props?.invoices?.length || 0}h packages</p>
           
                <p className='order_page_tooltip_2'> Details mentioned in packing slip</p>
              </Tooltip>
            }
          >

            <i class="bi bi-info-circle ml-1"></i>
          </OverlayTrigger></> : props?.invoices?.length} */}
          </td>
          {/* <td>{props.status}</td> */}
          {props.compo === "allOrders" && <><td></td></>}
          <td className=''>
            <div className='border-x'>
              <p className='text-end'><u className='fs-11 text-danger ff_pop'>Delivered On : {props.deliveredOn}</u></p>

              {props?.invoices?.length > 0 ?
                props?.invoices.map((item, index) => {
                  if (props?.invoices?.length > 3) {
                    if (index < 3) {
                      return (
                        <>
                          {index !== 0 && <hr className='my-1'></hr>}
                          <div className='order-track'>
                            <div className=''>
                              <span className=''>
                                Docket-
                              </span>
                              <strong className=' '>{item.docketNo}</strong>
                              <br></br>
                              <span className=''>
                                Courier- <strong>{item.shippingBy}</strong>
                              </span>
                            </div>
                            <div className='m-auto'>
                              {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                  <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                    <button className='track_btn'>Track</button>
                                  </a>
                                ) : (
                                  <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                    <button className='track_btn'>Track</button>
                                  </a>
                                )}

                            </div>
                          </div>

                        </>
                      )
                    }
                    else {
                      if (!showMore) {
                        if (index === 3) {
                          return (
                            <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                          )
                        }
                      }
                      else {
                        return (
                          <>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div className=''>
                                <span className=''>
                                  Docket-
                                </span>
                                <strong className=''>{item.docketNo}</strong>
                                <br></br>
                                <span className=''>
                                  Courier- <strong>{item.shippingBy}</strong>
                                </span>
                              </div>
                              <div className='m-auto'>
                                {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                    <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                      <button className='track_btn'>Track</button>
                                    </a>
                                  ) : (
                                    <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                      <button className='track_btn'>Track</button>
                                    </a>
                                  )}

                              </div>
                            </div>

                          </>
                        )
                      }
                    }
                  }
                  else {
                    return (
                      <>
                        {index !== 0 && <hr className='my-1'></hr>}
                        <div className='order-track'>
                          <div className=''>
                            <span className=''>
                              Docket-
                            </span>
                            <strong className=' '>{item.docketNo}</strong>
                            <br></br>
                            <span className=''>
                              Courier- <strong>{item.shippingBy}</strong>
                            </span>
                          </div>
                          <div className='m-auto'>
                                                      
                          {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                            <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                              <button className='track_btn'>Track</button>
                            </a>
                          ) : (
                            <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                              <button className='track_btn'>Track</button>
                            </a>
)}
                          </div>
                        </div>

                      </>
                    )
                  }
                })
                : <></>}

            </div>
            {props.orderStatus === "Partially delivered/RTO" && (
              <p className='rtoMsg text-danger'>Some parts are RTO</p>
            )}

            <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'><i className="bi bi-file-earmark-arrow-down"></i> Download Invoice</p>

          </td>

        </tr>
        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
      </>
    )
  }
  else if (props.status === "Lost" || props.status === "Partially delivered/Lost" || props.status === "Partially delivered/RTO") {
    return (
      <>
        <tr className='fs-14 f-700 color-row5 ord_table_row'>
          <td className='order_table_date'><div className='border-x'>
            {(props.product?.selfShip === true ||
              props.order?.products?.[0]?.productId?.selfShip === true) && (
                <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                  <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                </div>
              )}
            {props.orderId}
          </div></td>
          <td className='order_table_date'><div className='border-x'>{props.updatedAt}</div></td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
            </div>
          </td>
          <td>
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>
              {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
            </div>

          </td>
          {props.compo !== "allOrders" && stateData?.addresses?.data?.length > 0 && <td><div className='border-x'>
            <div className='order-ad'>{props.nicknameAdd}</div>
          </div></td>}
          {props.compo === "allOrders" && <td><div className='border-x'>
            {stateData?.addresses?.data?.length > 0 &&
              <div className='order-ad'>{props.nicknameAdd}</div>
            }
          </div></td>}
          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
            </div>
            {/* {props?.invoices?.length > 1 ? <>{props?.invoices?.length || 0}h  <OverlayTrigger
            key={props.id}
            placement="bottom"

            overlay={
              <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                <p className='f-500 order_page_tooltip_1'>This product will be dispatched in {props?.invoices?.length || 0}h packages</p>
           
                <p className='order_page_tooltip_2'> Details mentioned in packing slip</p>
              </Tooltip>
            }
          >
            <i class="bi bi-info-circle ms-1"></i>
          </OverlayTrigger></> : props.invoices.length} */}

          </td>
          {/* <td>{props.status}</td> */}
          {props.compo === "allOrders" && <><td></td></>}
          <td className=''>
            <div className='border-x'>
              <div style={{ background: "#FFBF00", padding: "2px 13px", borderRadius: "3px", color: "white", fontWeight: "500", fontSize: "10px", marginBottom: "10px" }}>{props.status}</div>

              {props?.invoices?.length > 0 ?
                props?.invoices.map((item, index) => {
                  if (props?.invoices?.length > 3) {
                    if (index < 3) {
                      return (
                        <>
                          {index !== 0 && <hr className='my-1'></hr>}
                          <div className='order-track'>
                            <div className=''>
                              <span className=''>
                                Docket-
                              </span>
                              <strong className=' '>{item.docketNo}</strong>
                              <br></br>
                              <span className=''>
                                Courier- <strong>{item.shippingBy}</strong>
                              </span>
                            </div>
                            <div className='m-auto'>
                              <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                <button className='track_btn'>Track</button>
                              </a>

                            </div>
                          </div>

                        </>
                      )
                    }
                    else {
                      if (!showMore) {
                        if (index === 3) {
                          return (
                            <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                          )
                        }
                      }
                      else {
                        return (
                          <>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div className=''>
                                <span className=''>
                                  Docket-
                                </span>
                                <strong className=''>{item.docketNo}</strong>
                                <br></br>
                                <span className=''>
                                  Courier- <strong>{item.shippingBy}</strong>
                                </span>
                              </div>
                             <div className='m-auto'>
                  {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                    <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                      <button className='track_btn'>Track</button>
                    </a>
                  ) : (
                    <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                      <button className='track_btn'>Track</button>
                    </a>
                  )}
                              </div>
                            </div>

                          </>
                        )
                      }
                    }
                  }
                  else {
                    return (
                      <>
                        {index !== 0 && <hr className='my-1'></hr>}
                        <div className='order-track'>
                          <div className=''>
                            <span className=''>
                              Docket-
                            </span>
                            <strong className=' '>{item.docketNo}</strong>
                            <br></br>
                            <span className=''>
                              Courier- <strong>{item.shippingBy}</strong>
                            </span>
                          </div>
                          <div className='m-auto'>
                            {/* <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                              <button className='track_btn'>Track</button>
                            </a> */}
                          {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                            <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                              <button className='track_btn'>Track</button>
                            </a>
                          ) : (
                            <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                              <button className='track_btn'>Track</button>
                            </a>
                          )}
                          </div>
                        </div>

                      </>
                    )
                  }
                })
                : <></>}

            </div>
            {props.orderStatus === "Partially delivered/RTO" && (
              <p className='rtoMsg text-danger'>Some parts are RTO</p>
            )}

            <p onClick={() => getSellerInvoice(props.orderMainId, props.orderId)} className='donwload-invoice-text'><i className="bi bi-file-earmark-arrow-down"></i> Download Invoice</p>

          </td>

        </tr>
        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
      </>
    )
  }
  else if (props.status == 'dispatch') {
    return (
      <>
        <tr className='fs-14 f-700 color-row ord_table_row'>
          <td className='order_table_date'>
            <div className='border-x'>
              {(props.product?.selfShip === true ||
                props.order?.products?.[0]?.productId?.selfShip === true) && (
                  <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                    <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                  </div>
                )}
              <div class="order-id">{props.orderId}</div>
              {/* <div className='order-date'>{props.date}</div> */}
            </div>
          </td>
          <td className='order_table_date'>
            <div className='border-x'>
              <div className='order-date'>{props.createddAt}</div>
            </div>
          </td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
            <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
            <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
          </Row> */}
              <ul className="d-flex ord-crd mb-0">
                {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                  return (
                    <>
                      <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{props.combination[index]} - {item}</li>
                    </>
                  )
                }) : <></>}

              </ul>
            </div>
          </td>
          <td className="order_table_price">
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>
              {/** Platform Fee Ticket : SL-662 */}
              {props?.platformFee != null && <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee}</div>}
              {/* <OverlayTrigger
            key={props.orderId}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
              </Tooltip>
            }
          >
            <i class="bi bi-info-circle ms-1"></i>
          </OverlayTrigger> */}
            </div>
          </td>
          {stateData?.addresses?.data?.length > 0 && <td>
            <div className='border-x'>
              <div className='order-ad'>{props.nicknameAdd}</div>
            </div>
          </td>}
          <td>
            {/* {props?.invoices?.length > 1 ? <>{props?.invoices?.length || 0}h  <OverlayTrigger
            key={props.id}
            rootClose
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-${props.id}`} className="order_page_tooltip">
                <p className='f-500 order_page_tooltip_1'>This product will be dispatched in {props?.invoices?.length || 0}h packages</p>
                 <br></br> 
                <p className='order_page_tooltip_2'> Details mentioned in packing slip</p>
              </Tooltip>
            }
          >
            <i class="bi bi-info-circle ms-1"></i>
          </OverlayTrigger></> : props.invoices.length} */}
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.pkgs?.length || 0}</div>
            </div>
          </td>
          {/* {props.compo === "allOrders" ? <></> : <td className={daydiffer > 3 ? "ord_date_pend_dan" : <></>}><div className='border-x'><div className={daydiffer > 3 ? "ord_date_pend_dan pending-days" : 'pending-days'}>{daydiffer} {dayVal}</div></div></td>} */}

          <td>

            {/* Button for assign */}
            <div className='border-x'>
              <div className='prod-price'>{props.redisStatus}</div><br />
              {(props.redisStatus == "Pickup pending" || props.redisStatus == "Order placed") && props?.invoices ? <><button className="download_manifest_btn_orders icon-but"  onClick={() => newDownloadManifestConfirmation(props?.pkgs, "Pickup Pending", props.lead, index, props.orderId, props.sku, props.orderMainId)}><span id={props.lead + index}>Download Manifest</span> <img src="/note.webp" /></button>

                {/* <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover[props.id]}>

              <i className="bi bi-info-circle theme-col fs-15" aria-hidden="true"></i>
            </OverlayTrigger> */}
              </>
                : <></>
              }
              {/* <p className='text-center ff_pop mt-1 '>Reassigned</p>
            <p className='text-black fs-11 ff_pop'>Cancelled Docket(s):- </p>

            <p className='text-black fs-11 ff_pop cancelled_dockets_cntn'>(
              {dNo.length > 0 && dNo.map((item, index) => {
                if (index !== dNo.length - 1) {
                  return (
                    <><span><del>{item}</del></span>,</>
                  )
                }
                else {
                  return (
                    <><span><del>{item}</del></span></>
                  )
                }


              })}

              )</p> */}

              {/* Track */}
              {props.redisStatus === "Delivered" && <p className='text-end'><u className='fs-11 text-danger ff_pop'>Delivered On : {props.deliveredOn}</u></p>}

              {props.redisStatus !== "Pickup pending" && props?.pkgs.length > 0 ?
                props?.pkgs.map((item, index) => {
                  if (props?.pkgs.length > 3) {
                    if (index < 3) {
                      return (
                        <>
                          {index !== 0 && <hr className='my-1'></hr>}
                          <div className='order-track'>
                            <div className=''>
                              <span className=''>
                                Docket-
                              </span>
                              <strong className=' '>{item.docketNo}</strong>
                              <br></br>
                              <span className=''>
                                Courier- <strong>{item.shippingBy}</strong>
                              </span>
                            </div>
                            <div className='m-auto'>
                              
                              {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                  <button className='track_btn'>Track</button>
                                </a>
                              ) : (
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>
                              )}
                            </div>
                          </div>

                        </>
                      )
                    }
                    else {
                      if (!showMore) {
                        if (index === 3) {
                          return (
                            <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                          )
                        }
                      }
                      else {
                        return (
                          <>
                            {index !== 0 && <hr className='my-1'></hr>}
                            <div className='order-track'>
                              <div className=''>
                                <span className=''>
                                  Docket-
                                </span>
                                <strong className=''>{item?.docketNo}</strong>
                                <br></br>
                                <span className=''>
                                  Courier- <strong>{item?.shippingBy}</strong>
                                </span>
                              </div>
                              <div className='m-auto'>
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>

                              </div>
                            </div>

                          </>
                        )
                      }
                    }
                  }
                  else {
                    return (
                      <>
                        {index !== 0 && <hr className='my-1'></hr>}
                        <div className='order-track'>
                          <div className=''>
                            <span className=''>
                              Docket-
                            </span>
                            <strong className=' '>{item?.docketNo}</strong>
                            <br></br>
                            <span className=''>
                              Courier- <strong>{item?.shippingBy}</strong>
                            </span>
                          </div>
                          <div className='m-auto'>
                            {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                              <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                <button className='track_btn'>Track</button>
                              </a>
                            ) : (
                              <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                <button className='track_btn'>Track</button>
                              </a>
                            )}
                          </div>
                        </div>

                      </>
                    )
                  }
                })
                : <></>}

            </div>
          </td>
        </tr>
        {/* Confirmation Modal */}
        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            selectedId={selectedenquiry}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmationOrderHist}
          />
        </Modal>

        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}
      </>
    )
  }
  else if (props.status == 'reverse') {
    const getPackageStatusDisplay = (docketStatus) => {
      switch (docketStatus) {
        case "Pickup Pending":
          return "Pickup pending";
        case "Docket not live":
          return "Revoked";
        case "In transit":
        case "in transit":
          return "In transit";
        case "Delivered":
        case "delivered":
          return "Delivered";
        case "Order Placed":
        case "Order placed":
          return "Pickup pending";
        default:
          return docketStatus || "Unknown";
      }
    }

    const getPackageBadgeClass = (docketStatus) => {
      const displayStatus = getPackageStatusDisplay(docketStatus);
      switch (displayStatus) {
        case 'Pickup pending':
          return 'bg-warning text-dark';
        case 'Revoked':
          return 'bg-danger';
        case 'In transit':
          return 'bg-info';
        case 'Delivered':
          return 'bg-success';
        default:
          return 'bg-light text-dark';
      }
    };

    return (
      <>
        <tr className='fs-14 f-700 color-row ord_table_row'>
          <td className='order_table_date'>
            <div className='border-x'>
              {(props.product?.selfShip === true ||
                props.order?.products?.[0]?.productId?.selfShip === true) && (
                  <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                    <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                  </div>
                )}
              <div class="order-id">{props.orderId}</div>
            </div>
          </td>
          <td className='order_table_date'>
            <div className='border-x'>
              <div className='order-date'>{props.createddAt}</div>
            </div>
          </td>
          <td className='td-img-cntn'>
            <div className='border-x'>
              <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
            </div>
          </td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'>
                <button className='px-1 order_table_btn_details'>Details</button>
              </a>
              <ul className="d-flex ord-crd mb-0">
                {props.selSubPrdVal ? props.selSubPrdVal.map((item, index) => {
                  return (
                    <>
                      <li className="bg-theme p-1 m-1 text-white fs-11 corner ff_pop">
                        {props.combination[index]} - {item}
                      </li>
                    </>
                  )
                }) : <></>}
              </ul>
            </div>
          </td>
          <td className="order_table_price">
            <div className='border-x'>
              <div className='prod-price'>
                <i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}
              </div>
              <div className='prod-gst'>{props?.taxClass ? (
                <>
                  (incl. <strong>{props.taxClass}%</strong> GST)
                </>
              ) : (
                "GST missing"
              )}</div>
            </div>
          </td>
          {/* <td>
            <div className='border-x'>
              <div className='order-ad'>{props.nicknameAdd}</div>
            </div>
          </td> */}
          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>
                {props?.pkgs?.length || 0}
              </div>
            </div>
          </td>

          <td>
            <div className='border-x'>
              {/* <div className='mb-2'>
                <span className={`badge ${props.reverseStatus === 'Pickup pending' ? 'bg-warning' :
                  props.reverseStatus === 'Revoked' ? 'bg-danger' :
                    props.reverseStatus === 'In transit' ? 'bg-info' :
                      props.reverseStatus === 'Delivered' ? 'bg-success' :
                        'bg-light text-dark'
                  }`}>
                  {props.reverseStatus}
                </span>
              </div> */}

              {/* Track Button - Show for all statuses except Pickup pending */}

              {props?.pkgs && props?.pkgs?.length > 0 ?
                props?.pkgs.map((item, index) => {
                  const packageStatus = getPackageStatusDisplay(item?.docketStatus);
                  const showTrackButton = packageStatus !== 'Pickup pending';
                  if (props?.pkgs.length > 3) {
                    if (index < 3) {
                      return (
                        <>
                          {index !== 0 && <hr className='my-1'></hr>}

                          <div className='order-track'>
                            <div className=''>
                              <span className=''>
                                Docket-
                              </span>
                              <strong className=' '>{item.docketNo}</strong>
                              <br></br>
                              <span className=''>
                                Courier- <strong>{item.shippingBy}</strong>
                              </span>
                            </div>
                            <div className='m-auto'>
                             
                                {item.cId === 0 && item.trackingLink && item.trackingLink ? (
                                <a href={item.trackingLink} target="_blank" rel="noopener noreferrer">
                                  <button className='track_btn'>Track</button>
                                </a>
                              ) : (
                                <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>
                              )}
                            </div>
                          </div>

                        </>
                      )
                    }
                    else {
                      if (!showMore) {
                        if (index === 3) {
                          return (
                            <span onClick={() => setShowMore(!showMore)} role="button" className='text-primary '>Load More...</span>
                          )
                        }
                      }
                      else {
                        return (
                          <>
                            {index !== 0 && <hr className='my-1'></hr>}

                            <div className='order-track'>
                              <div className=''>
                                <span className=''>
                                  Docket-
                                </span>
                                <strong className=''>{item?.docketNo}</strong>
                                <br></br>
                                <span className=''>
                                  Courier- <strong>{item?.shippingBy}</strong>
                                </span>
                              </div>
                              <div className='m-auto'>
                                {showTrackButton && <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                                  <button className='track_btn'>Track</button>
                                </a>}

                              </div>
                            </div>
                            <div className='mb-2'>
                              <span className={`badge ${props.reverseStatus === 'Pickup pending' ? 'bg-warning' :
                                props.reverseStatus === 'Revoked' ? 'bg-danger' :
                                  props.reverseStatus === 'In transit' ? 'bg-info' :
                                    props.reverseStatus === 'Delivered' ? 'bg-success' :
                                      'bg-light text-dark'
                                }`}>
                                {props.reverseStatus}
                              </span>
                            </div>

                          </>
                        )
                      }
                    }
                  }
                  else {
                    return (
                      <>
                        {index !== 0 && <hr className='my-1'></hr>}
                        <div className='mb-2'>
                          <span className={`badge ${props.reverseStatus === 'Pickup pending' ? 'bg-warning' :
                            props.reverseStatus === 'Revoked' ? 'bg-danger' :
                              props.reverseStatus === 'In transit' ? 'bg-info' :
                                props.reverseStatus === 'Delivered' ? 'bg-success' :
                                  'bg-light text-dark'
                            }`}>
                            {packageStatus}
                          </span>
                        </div>
                        <div className='order-track'>
                          <div className=''>
                            <span className=''>
                              Docket-
                            </span>
                            <strong className=' '>{item?.docketNo}</strong>
                            <br></br>
                            <span className=''>
                              Courier- <strong>{item?.shippingBy}</strong>
                            </span>
                          </div>
                          <div className='m-auto'>
                            {showTrackButton && <a href="#popupTrackweb" onClick={() => sendData(index, item.docketNo)}>
                              <button className='track_btn'>Track</button>
                            </a>}

                          </div>
                        </div>

                      </>
                    )
                  }
                })
                : <></>}

              {!props?.pkgs || props?.pkgs?.length < 1 ? <>
                {index !== 0 && <hr className='my-1'></hr>}
                <div className='mb-2'>
                  <span className={`badge ${props.reverseStatus === 'Pickup pending' ? 'bg-warning' :
                    props.reverseStatus === 'Revoked' ? 'bg-danger' :
                      props.reverseStatus === 'In transit' ? 'bg-info' :
                        props.reverseStatus === 'Delivered' ? 'bg-success' :
                          'bg-light text-dark'
                    }`}>
                    {props?.reverseStatus || "Unknown"}
                  </span>
                </div>
                <div className="text-center">
                  {props.reverseStatus === "Pickup pending" ? (
                    <button
                      className="btn btn-success btn-sm fs-12 px-3"
                      onClick={() => {
                        if (props.isProductPickedFun) {
                          props.isProductPickedFun(props?.lead, "DOWNLOAD", props?.productName);
                        }
                      }}
                    >
                      Mark as Picked <i className='fa fa-check'></i>
                    </button>
                  ) : (
                    <span className='fs-12 text-muted'>Tracking not available</span>
                  )}
                </div>

              </> : <></>}

              {/* For Pickup pending - no special button needed, just the status */}

              {/* Delivered Date */}
              {props.reverseStatus === "Delivered" && (
                <p className='text-end mt-2'>
                  <u className='fs-11 text-danger ff_pop'>Delivered On : {props.deliveredOn}</u>
                </p>
              )}
            </div>
          </td>
        </tr>

        {/* Confirmation Modal */}
        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            selectedId={selectedenquiry}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmationOrderHist}
          />
        </Modal>

        {packageData ?
          <PackageDetailsModal
            show={showPackageDetails}
            handleClose={() => { setShowPackageDetails(false) }}
            data={packageData}
          /> : ""
        }
      </>
    )
  }
  else {
    return (
      <>
        <tr className='fs-14 f-700 color-row5 ord_table_row'>
          <td className='order_table_date'><div className='border-x'>
            {(props.product?.selfShip === true ||
              props.order?.products?.[0]?.productId?.selfShip === true) && (
                <div className="self-ship-tag mb-1" style={{ display: 'inline-block', marginBottom: '4px' }}>
                  <span className="badge" style={{ backgroundColor: '#ff9800', color: '#fff', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '3px', textTransform: 'uppercase' }}>Self-Ship</span>
                </div>
              )}
            <div class="order-id">{props.orderId}</div>
          </div></td>
          <td className='order_table_date'> <div className='border-x'>
            <div className='order-date'>{props.date}</div>
          </div></td>
          <td className='td-img-cntn'> <div className='border-x'>
            <img onClick={() => detailnew(props.url)} src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="product-i" />
          </div></td>
          <td className='fs-13 order_table_pname_cntn'>
            <div className='border-x inline-initial'>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='prod-name'> {props.productName}</a>
              <div className='order_table_sku'>SKU:- {props.sku}</div>
              <div className='ord_table_quantity'>Quantity:- {props.quantity}</div>
              <a href='#popupDetail' onClick={() => detailnew(props.url)} className='detail-but'><button className='px-1 order_table_btn_details'>Details</button></a>
              {/* <Row>
                <div className='col-8 ord_table_quantity'>Quantity:- {props.quantity}</div>
                <div className='col-4'><a href='#popupDetail' onClick={() => detailnew(props.url)}><button className='px-1 order_table_btn_details'>Details</button></a></div>
              </Row> */}
            </div>
          </td>
          <td>
            <div className='border-x'>
              <div className='prod-price'><i class="fa fa-inr" aria-hidden="true"></i> {parseInt(props.price * props.quantity)}</div>
              <div className='prod-gst'>
                {props?.taxClass ? (
                  <>(incl. <strong>{props.taxClass}%</strong> GST)</>
                ) : (
                  "GST missing"
                )}
              </div>

              {/** Platform Fee Ticket : SL-662 & I1-2262 */}
              <div className='prod-platformfee'>Platform Fee <i class="fa fa-inr" aria-hidden="true" style={{ fontWeight: 400 }}></i> {props?.platformFee != null ? props.platformFee : 0}</div>
              {/* <OverlayTrigger
                key={props.orderId}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${props.orderId}`} className="order_page_tooltip">
                    <p className='f-500 order_page_tooltip_1'>{variables.transferPriceText}({props.taxClass}%)</p>
                  </Tooltip>
                }
              >
                <i class="bi bi-info-circle ms-1"></i>
              </OverlayTrigger> */}
            </div>
          </td>
          {stateData?.addresses?.data?.length > 0 && <td><div className='border-x'>
            <div className='order-ad'>{props.nicknameAdd}</div>
          </div></td>}
          <td>
            <div className='border-x'>
              <div className='package-cunt' onClick={() => openPackage(props?.invoices)}>{props?.invoices?.length || 0}</div>
            </div>
          </td>
          {/* <td>{props.status}</td> */}

          <td>
            <div className='border-x'>
              {props.status}
              {props.status === "DELIVERED" ? <><br></br><span className=' revoke_ord_sta_nd'>Delivered on : {props.deliveredOn}</span></> : <></>}

            </div>
          </td>

        </tr>
        {packageData ? <PackageDetailsModal show={showPackageDetails} handleClose={() => { setShowPackageDetails(false) }} data={packageData} /> : ""}

      </>
    )

  }


  {/* ADD THIS MODAL HERE - Before the final closing */ }
  <OrderSelfship
    show={showSelfShipModal}
    handleClose={handleCloseSelfShipModal}
    orderData={selectedSelfShipOrder}
    onSubmit={handleSelfShipSubmit}
  />
}



export default OrderCardWeb;